export const predefinedCode = {
    slc_dev_t: `
// Copyright 2015-2018 Espressif Systems (Shanghai) PTE LTD
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at

//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
#ifndef _SOC_SLC_STRUCT_H_
#define _SOC_SLC_STRUCT_H_

#include <stdint.h>

#ifdef __cplusplus
extern "C" {
#endif

typedef volatile struct slc_dev_s {
    union {
        struct {
            uint32_t slc0_tx_rst:         1;
            uint32_t slc0_rx_rst:         1;
            uint32_t ahbm_fifo_rst:       1;
            uint32_t ahbm_rst:            1;
            uint32_t slc0_tx_loop_test:   1;
            uint32_t slc0_rx_loop_test:   1;
            uint32_t slc0_rx_auto_wrback: 1;
            uint32_t slc0_rx_no_restart_clr: 1;
            uint32_t slc0_rxdscr_burst_en: 1;
            uint32_t slc0_rxdata_burst_en: 1;
            uint32_t slc0_rxlink_auto_ret: 1;
            uint32_t slc0_txlink_auto_ret: 1;
            uint32_t slc0_txdscr_burst_en: 1;
            uint32_t slc0_txdata_burst_en: 1;
            uint32_t slc0_token_auto_clr: 1;
            uint32_t slc0_token_sel:      1;
            uint32_t slc1_tx_rst:         1;
            uint32_t slc1_rx_rst:         1;
            uint32_t slc0_wr_retry_mask_en: 1;
            uint32_t slc1_wr_retry_mask_en: 1;
            uint32_t slc1_tx_loop_test:   1;
            uint32_t slc1_rx_loop_test:   1;
            uint32_t slc1_rx_auto_wrback: 1;
            uint32_t slc1_rx_no_restart_clr: 1;
            uint32_t slc1_rxdscr_burst_en: 1;
            uint32_t slc1_rxdata_burst_en: 1;
            uint32_t slc1_rxlink_auto_ret: 1;
            uint32_t slc1_txlink_auto_ret: 1;
            uint32_t slc1_txdscr_burst_en: 1;
            uint32_t slc1_txdata_burst_en: 1;
            uint32_t slc1_token_auto_clr: 1;
            uint32_t slc1_token_sel:      1;
        };
        uint32_t val;
    } conf0;
    union {
        struct {
            uint32_t frhost_bit0:             1;
            uint32_t frhost_bit1:             1;
            uint32_t frhost_bit2:             1;
            uint32_t frhost_bit3:             1;
            uint32_t frhost_bit4:             1;
            uint32_t frhost_bit5:             1;
            uint32_t frhost_bit6:             1;
            uint32_t frhost_bit7:             1;
            uint32_t rx_start:                1;
            uint32_t tx_start:                1;
            uint32_t rx_udf:                  1;
            uint32_t tx_ovf:                  1;
            uint32_t token0_1to0:             1;
            uint32_t token1_1to0:             1;
            uint32_t tx_done:                 1;
            uint32_t tx_suc_eof:              1;
            uint32_t rx_done:                 1;
            uint32_t rx_eof:                  1;
            uint32_t tohost:                  1;
            uint32_t tx_dscr_err:             1;
            uint32_t rx_dscr_err:             1;
            uint32_t tx_dscr_empty:           1;
            uint32_t host_rd_ack:             1;
            uint32_t wr_retry_done:           1;
            uint32_t tx_err_eof:              1;
            uint32_t cmd_dtc:                 1;
            uint32_t rx_quick_eof:            1;
            uint32_t reserved27:              5;
        };
        uint32_t val;
    } slc0_int_raw;
    union {
        struct {
            uint32_t frhost_bit0:            1;
            uint32_t frhost_bit1:            1;
            uint32_t frhost_bit2:            1;
            uint32_t frhost_bit3:            1;
            uint32_t frhost_bit4:            1;
            uint32_t frhost_bit5:            1;
            uint32_t frhost_bit6:            1;
            uint32_t frhost_bit7:            1;
            uint32_t rx_start:               1;
            uint32_t tx_start:               1;
            uint32_t rx_udf:                 1;
            uint32_t tx_ovf:                 1;
            uint32_t token0_1to0:            1;
            uint32_t token1_1to0:            1;
            uint32_t tx_done:                1;
            uint32_t tx_suc_eof:             1;
            uint32_t rx_done:                1;
            uint32_t rx_eof:                 1;
            uint32_t tohost:                 1;
            uint32_t tx_dscr_err:            1;
            uint32_t rx_dscr_err:            1;
            uint32_t tx_dscr_empty:          1;
            uint32_t host_rd_ack:            1;
            uint32_t wr_retry_done:          1;
            uint32_t tx_err_eof:             1;
            uint32_t cmd_dtc:                1;
            uint32_t rx_quick_eof:           1;
            uint32_t reserved27:             5;
        };
        uint32_t val;
    } slc0_int_st;
    union {
        struct {
            uint32_t frhost_bit0:             1;
            uint32_t frhost_bit1:             1;
            uint32_t frhost_bit2:             1;
            uint32_t frhost_bit3:             1;
            uint32_t frhost_bit4:             1;
            uint32_t frhost_bit5:             1;
            uint32_t frhost_bit6:             1;
            uint32_t frhost_bit7:             1;
            uint32_t rx_start:                1;
            uint32_t tx_start:                1;
            uint32_t rx_udf:                  1;
            uint32_t tx_ovf:                  1;
            uint32_t token0_1to0:             1;
            uint32_t token1_1to0:             1;
            uint32_t tx_done:                 1;
            uint32_t tx_suc_eof:              1;
            uint32_t rx_done:                 1;
            uint32_t rx_eof:                  1;
            uint32_t tohost:                  1;
            uint32_t tx_dscr_err:             1;
            uint32_t rx_dscr_err:             1;
            uint32_t tx_dscr_empty:           1;
            uint32_t host_rd_ack:             1;
            uint32_t wr_retry_done:           1;
            uint32_t tx_err_eof:              1;
            uint32_t cmd_dtc:                 1;
            uint32_t rx_quick_eof:            1;
            uint32_t reserved27:              5;
        };
        uint32_t val;
    } slc0_int_ena;
    union {
        struct {
            uint32_t frhost_bit0:             1;
            uint32_t frhost_bit1:             1;
            uint32_t frhost_bit2:             1;
            uint32_t frhost_bit3:             1;
            uint32_t frhost_bit4:             1;
            uint32_t frhost_bit5:             1;
            uint32_t frhost_bit6:             1;
            uint32_t frhost_bit7:             1;
            uint32_t rx_start:                1;
            uint32_t tx_start:                1;
            uint32_t rx_udf:                  1;
            uint32_t tx_ovf:                  1;
            uint32_t token0_1to0:             1;
            uint32_t token1_1to0:             1;
            uint32_t tx_done:                 1;
            uint32_t tx_suc_eof:              1;
            uint32_t rx_done:                 1;
            uint32_t rx_eof:                  1;
            uint32_t tohost:                  1;
            uint32_t tx_dscr_err:             1;
            uint32_t rx_dscr_err:             1;
            uint32_t tx_dscr_empty:           1;
            uint32_t host_rd_ack:             1;
            uint32_t wr_retry_done:           1;
            uint32_t tx_err_eof:              1;
            uint32_t cmd_dtc:                 1;
            uint32_t rx_quick_eof:            1;
            uint32_t reserved27:              5;
        };
        uint32_t val;
    } slc0_int_clr;
    union {
        struct {
            uint32_t frhost_bit8:             1;
            uint32_t frhost_bit9:             1;
            uint32_t frhost_bit10:            1;
            uint32_t frhost_bit11:            1;
            uint32_t frhost_bit12:            1;
            uint32_t frhost_bit13:            1;
            uint32_t frhost_bit14:            1;
            uint32_t frhost_bit15:            1;
            uint32_t rx_start:                1;
            uint32_t tx_start:                1;
            uint32_t rx_udf:                  1;
            uint32_t tx_ovf:                  1;
            uint32_t token0_1to0:             1;
            uint32_t token1_1to0:             1;
            uint32_t tx_done:                 1;
            uint32_t tx_suc_eof:              1;
            uint32_t rx_done:                 1;
            uint32_t rx_eof:                  1;
            uint32_t tohost:                  1;
            uint32_t tx_dscr_err:             1;
            uint32_t rx_dscr_err:             1;
            uint32_t tx_dscr_empty:           1;
            uint32_t host_rd_ack:             1;
            uint32_t wr_retry_done:           1;
            uint32_t tx_err_eof:              1;
            uint32_t reserved25:              7;
        };
        uint32_t val;
    } slc1_int_raw;
    union {
        struct {
            uint32_t frhost_bit8:            1;
            uint32_t frhost_bit9:            1;
            uint32_t frhost_bit10:           1;
            uint32_t frhost_bit11:           1;
            uint32_t frhost_bit12:           1;
            uint32_t frhost_bit13:           1;
            uint32_t frhost_bit14:           1;
            uint32_t frhost_bit15:           1;
            uint32_t rx_start:               1;
            uint32_t tx_start:               1;
            uint32_t rx_udf:                 1;
            uint32_t tx_ovf:                 1;
            uint32_t token0_1to0:            1;
            uint32_t token1_1to0:            1;
            uint32_t tx_done:                1;
            uint32_t tx_suc_eof:             1;
            uint32_t rx_done:                1;
            uint32_t rx_eof:                 1;
            uint32_t tohost:                 1;
            uint32_t tx_dscr_err:            1;
            uint32_t rx_dscr_err:            1;
            uint32_t tx_dscr_empty:          1;
            uint32_t host_rd_ack:            1;
            uint32_t wr_retry_done:          1;
            uint32_t tx_err_eof:             1;
            uint32_t reserved25:             7;
        };
        uint32_t val;
    } slc1_int_st;
    union {
        struct {
            uint32_t frhost_bit8:             1;
            uint32_t frhost_bit9:             1;
            uint32_t frhost_bit10:            1;
            uint32_t frhost_bit11:            1;
            uint32_t frhost_bit12:            1;
            uint32_t frhost_bit13:            1;
            uint32_t frhost_bit14:            1;
            uint32_t frhost_bit15:            1;
            uint32_t rx_start:                1;
            uint32_t tx_start:                1;
            uint32_t rx_udf:                  1;
            uint32_t tx_ovf:                  1;
            uint32_t token0_1to0:             1;
            uint32_t token1_1to0:             1;
            uint32_t tx_done:                 1;
            uint32_t tx_suc_eof:              1;
            uint32_t rx_done:                 1;
            uint32_t rx_eof:                  1;
            uint32_t tohost:                  1;
            uint32_t tx_dscr_err:             1;
            uint32_t rx_dscr_err:             1;
            uint32_t tx_dscr_empty:           1;
            uint32_t host_rd_ack:             1;
            uint32_t wr_retry_done:           1;
            uint32_t tx_err_eof:              1;
            uint32_t reserved25:              7;
        };
        uint32_t val;
    } slc1_int_ena;
    union {
        struct {
            uint32_t frhost_bit8:             1;
            uint32_t frhost_bit9:             1;
            uint32_t frhost_bit10:            1;
            uint32_t frhost_bit11:            1;
            uint32_t frhost_bit12:            1;
            uint32_t frhost_bit13:            1;
            uint32_t frhost_bit14:            1;
            uint32_t frhost_bit15:            1;
            uint32_t rx_start:                1;
            uint32_t tx_start:                1;
            uint32_t rx_udf:                  1;
            uint32_t tx_ovf:                  1;
            uint32_t token0_1to0:             1;
            uint32_t token1_1to0:             1;
            uint32_t tx_done:                 1;
            uint32_t tx_suc_eof:              1;
            uint32_t rx_done:                 1;
            uint32_t rx_eof:                  1;
            uint32_t tohost:                  1;
            uint32_t tx_dscr_err:             1;
            uint32_t rx_dscr_err:             1;
            uint32_t tx_dscr_empty:           1;
            uint32_t host_rd_ack:             1;
            uint32_t wr_retry_done:           1;
            uint32_t tx_err_eof:              1;
            uint32_t reserved25:              7;
        };
        uint32_t val;
    } slc1_int_clr;
    union {
        struct {
            uint32_t slc0_rx_full: 1;
            uint32_t slc0_rx_empty: 1;
            uint32_t reserved2: 14;
            uint32_t slc1_rx_full: 1;
            uint32_t slc1_rx_empty: 1;
            uint32_t reserved18:14;
        };
        uint32_t val;
    } rx_status;
    union {
        struct {
            uint32_t rxfifo_wdata:   9;
            uint32_t reserved9:      7;
            uint32_t rxfifo_push:    1;
            uint32_t reserved17:    15;
        };
        uint32_t val;
    } slc0_rxfifo_push;
    union {
        struct {
            uint32_t rxfifo_wdata:   9;
            uint32_t reserved9:      7;
            uint32_t rxfifo_push:    1;
            uint32_t reserved17:    15;
        };
        uint32_t val;
    } slc1_rxfifo_push;
    union {
        struct {
            uint32_t slc0_tx_full: 1;
            uint32_t slc0_tx_empty: 1;
            uint32_t reserved2: 14;
            uint32_t slc1_tx_full: 1;
            uint32_t slc1_tx_empty: 1;
            uint32_t reserved18:14;
        };
        uint32_t val;
    } tx_status;
    union {
        struct {
            uint32_t txfifo_rdata:  11;
            uint32_t reserved11:     5;
            uint32_t txfifo_pop:     1;
            uint32_t reserved17:    15;
        };
        uint32_t val;
    } slc0_txfifo_pop;
    union {
        struct {
            uint32_t txfifo_rdata:  11;
            uint32_t reserved11:     5;
            uint32_t txfifo_pop:     1;
            uint32_t reserved17:    15;
        };
        uint32_t val;
    } slc1_txfifo_pop;
    union {
        struct {
            uint32_t addr:            20;
            uint32_t reserved20:       8;
            uint32_t stop:             1;
            uint32_t start:            1;
            uint32_t restart:          1;
            uint32_t park:             1;
        };
        uint32_t val;
    } slc0_rx_link;
    union {
        struct {
            uint32_t addr:            20;
            uint32_t reserved20:       8;
            uint32_t stop:             1;
            uint32_t start:            1;
            uint32_t restart:          1;
            uint32_t park:             1;
        };
        uint32_t val;
    } slc0_tx_link;
    union {
        struct {
            uint32_t addr:            20;
            uint32_t bt_packet:        1;
            uint32_t reserved21:       7;
            uint32_t stop:             1;
            uint32_t start:            1;
            uint32_t restart:          1;
            uint32_t park:             1;
        };
        uint32_t val;
    } slc1_rx_link;
    union {
        struct {
            uint32_t addr:            20;
            uint32_t reserved20:       8;
            uint32_t stop:             1;
            uint32_t start:            1;
            uint32_t restart:          1;
            uint32_t park:             1;
        };
        uint32_t val;
    } slc1_tx_link;
    union {
        struct {
            uint32_t slc0_intvec:     8;
            uint32_t reserved8:       8;
            uint32_t slc1_intvec:     8;
            uint32_t reserved24:      8;
        };
        uint32_t val;
    } intvec_tohost;
    union {
        struct {
            uint32_t wdata:            12;
            uint32_t wr:                1;
            uint32_t inc:               1;
            uint32_t inc_more:          1;
            uint32_t reserved15:        1;
            uint32_t token0:           12;
            uint32_t reserved28:        4;
        };
        uint32_t val;
    } slc0_token0;
    union {
        struct {
            uint32_t wdata:            12;
            uint32_t wr:                1;
            uint32_t inc:               1;
            uint32_t inc_more:          1;
            uint32_t reserved15:        1;
            uint32_t token1:           12;
            uint32_t reserved28:        4;
        };
        uint32_t val;
    } slc0_token1;
    union {
        struct {
            uint32_t wdata:            12;
            uint32_t wr:                1;
            uint32_t inc:               1;
            uint32_t inc_more:          1;
            uint32_t reserved15:        1;
            uint32_t token0:           12;
            uint32_t reserved28:        4;
        };
        uint32_t val;
    } slc1_token0;
    union {
        struct {
            uint32_t wdata:            12;
            uint32_t wr:                1;
            uint32_t inc:               1;
            uint32_t inc_more:          1;
            uint32_t reserved15:        1;
            uint32_t token1:           12;
            uint32_t reserved28:        4;
        };
        uint32_t val;
    } slc1_token1;
    union {
        struct {
            uint32_t slc0_check_owner:   1;
            uint32_t slc0_tx_check_sum_en: 1;
            uint32_t slc0_rx_check_sum_en: 1;
            uint32_t cmd_hold_en:        1;
            uint32_t slc0_len_auto_clr:  1;
            uint32_t slc0_tx_stitch_en:  1;
            uint32_t slc0_rx_stitch_en:  1;
            uint32_t reserved7:          9;
            uint32_t slc1_check_owner:   1;
            uint32_t slc1_tx_check_sum_en: 1;
            uint32_t slc1_rx_check_sum_en: 1;
            uint32_t host_int_level_sel: 1;
            uint32_t slc1_tx_stitch_en:  1;
            uint32_t slc1_rx_stitch_en:  1;
            uint32_t clk_en:             1;
            uint32_t reserved23:         9;
        };
        uint32_t val;
    } conf1;
    uint32_t slc0_state0;                                  /**/
    uint32_t slc0_state1;                                  /**/
    uint32_t slc1_state0;                                  /**/
    uint32_t slc1_state1;                                  /**/
    union {
        struct {
            uint32_t txeof_ena:        6;
            uint32_t reserved6:        2;
            uint32_t fifo_map_ena:     4;
            uint32_t slc0_tx_dummy_mode: 1;
            uint32_t hda_map_128k:     1;
            uint32_t slc1_tx_dummy_mode: 1;
            uint32_t reserved15:       1;
            uint32_t tx_push_idle_num:16;
        };
        uint32_t val;
    } bridge_conf;
    uint32_t slc0_to_eof_des_addr;                         /**/
    uint32_t slc0_tx_eof_des_addr;                         /**/
    uint32_t slc0_to_eof_bfr_des_addr;                     /**/
    uint32_t slc1_to_eof_des_addr;                         /**/
    uint32_t slc1_tx_eof_des_addr;                         /**/
    uint32_t slc1_to_eof_bfr_des_addr;                     /**/
    union {
        struct {
            uint32_t mode:         3;
            uint32_t reserved3:    1;
            uint32_t addr:         2;
            uint32_t reserved6:   26;
        };
        uint32_t val;
    } ahb_test;
    union {
        struct {
            uint32_t cmd_st:          3;
            uint32_t reserved3:       1;
            uint32_t func_st:         4;
            uint32_t sdio_wakeup:     1;
            uint32_t reserved9:       3;
            uint32_t bus_st:          3;
            uint32_t reserved15:      1;
            uint32_t func1_acc_state: 5;
            uint32_t reserved21:      3;
            uint32_t func2_acc_state: 5;
            uint32_t reserved29:      3;
        };
        uint32_t val;
    } sdio_st;
    union {
        struct {
            uint32_t slc0_token_no_replace: 1;
            uint32_t slc0_infor_no_replace: 1;
            uint32_t slc0_rx_fill_mode:    1;
            uint32_t slc0_rx_eof_mode:     1;
            uint32_t slc0_rx_fill_en:      1;
            uint32_t slc0_rd_retry_threshold:11;
            uint32_t slc1_token_no_replace: 1;
            uint32_t slc1_infor_no_replace: 1;
            uint32_t slc1_rx_fill_mode:    1;
            uint32_t slc1_rx_eof_mode:     1;
            uint32_t slc1_rx_fill_en:      1;
            uint32_t slc1_rd_retry_threshold:11;
        };
        uint32_t val;
    } rx_dscr_conf;
    uint32_t slc0_txlink_dscr;                             /**/
    uint32_t slc0_txlink_dscr_bf0;                         /**/
    uint32_t slc0_txlink_dscr_bf1;                         /**/
    uint32_t slc0_rxlink_dscr;                             /**/
    uint32_t slc0_rxlink_dscr_bf0;                         /**/
    uint32_t slc0_rxlink_dscr_bf1;                         /**/
    uint32_t slc1_txlink_dscr;                             /**/
    uint32_t slc1_txlink_dscr_bf0;                         /**/
    uint32_t slc1_txlink_dscr_bf1;                         /**/
    uint32_t slc1_rxlink_dscr;                             /**/
    uint32_t slc1_rxlink_dscr_bf0;                         /**/
    uint32_t slc1_rxlink_dscr_bf1;                         /**/
    uint32_t slc0_tx_erreof_des_addr;                      /**/
    uint32_t slc1_tx_erreof_des_addr;                      /**/
    union {
        struct {
            uint32_t slc0_token:12;
            uint32_t reserved12: 4;
            uint32_t slc1_token:12;
            uint32_t reserved28: 4;
        };
        uint32_t val;
    } token_lat;
    union {
        struct {
            uint32_t wr_retry_threshold:11;
            uint32_t reserved11:        21;
        };
        uint32_t val;
    } tx_dscr_conf;
    uint32_t cmd_infor0;                                /**/
    uint32_t cmd_infor1;                                /**/
    union {
        struct {
            uint32_t len_wdata:          20;
            uint32_t len_wr:              1;
            uint32_t len_inc:             1;
            uint32_t len_inc_more:        1;
            uint32_t rx_packet_load_en:   1;
            uint32_t tx_packet_load_en:   1;
            uint32_t rx_get_used_dscr:    1;
            uint32_t tx_get_used_dscr:    1;
            uint32_t rx_new_pkt_ind:      1;
            uint32_t tx_new_pkt_ind:      1;
            uint32_t reserved29:          3;
        };
        uint32_t val;
    } slc0_len_conf;
    union {
        struct {
            uint32_t len:       20;
            uint32_t reserved20:12;
        };
        uint32_t val;
    } slc0_length;
    uint32_t slc0_txpkt_h_dscr;                            /**/
    uint32_t slc0_txpkt_e_dscr;                            /**/
    uint32_t slc0_rxpkt_h_dscr;                            /**/
    uint32_t slc0_rxpkt_e_dscr;                            /**/
    uint32_t slc0_txpktu_h_dscr;                           /**/
    uint32_t slc0_txpktu_e_dscr;                           /**/
    uint32_t slc0_rxpktu_h_dscr;                           /**/
    uint32_t slc0_rxpktu_e_dscr;                           /**/
    uint32_t reserved_10c;
    uint32_t reserved_110;
    union {
        struct {
            uint32_t slc0_position:  8;
            uint32_t slc1_position:  8;
            uint32_t reserved16:    16;
        };
        uint32_t val;
    } seq_position;
    union {
        struct {
            uint32_t rx_dscr_rec_lim:  10;
            uint32_t reserved10:       22;
        };
        uint32_t val;
    } slc0_dscr_rec_conf;
    union {
        struct {
            uint32_t dat0_crc_err_cnt: 8;
            uint32_t dat1_crc_err_cnt: 8;
            uint32_t dat2_crc_err_cnt: 8;
            uint32_t dat3_crc_err_cnt: 8;
        };
        uint32_t val;
    } sdio_crc_st0;
    union {
        struct {
            uint32_t cmd_crc_err_cnt: 8;
            uint32_t reserved8:      23;
            uint32_t err_cnt_clr:     1;
        };
        uint32_t val;
    } sdio_crc_st1;
    uint32_t slc0_eof_start_des;                           /**/
    uint32_t slc0_push_dscr_addr;                          /**/
    uint32_t slc0_done_dscr_addr;                          /**/
    uint32_t slc0_sub_start_des;                           /**/
    union {
        struct {
            uint32_t rx_dscr_cnt_lat:  10;
            uint32_t reserved10:        6;
            uint32_t rx_get_eof_occ:    1;
            uint32_t reserved17:       15;
        };
        uint32_t val;
    } slc0_dscr_cnt;
    union {
        struct {
            uint32_t len_lim:   20;
            uint32_t reserved20:12;
        };
        uint32_t val;
    } slc0_len_lim_conf;
    union {
        struct {
            uint32_t frhost_bit01:            1;
            uint32_t frhost_bit11:            1;
            uint32_t frhost_bit21:            1;
            uint32_t frhost_bit31:            1;
            uint32_t frhost_bit41:            1;
            uint32_t frhost_bit51:            1;
            uint32_t frhost_bit61:            1;
            uint32_t frhost_bit71:            1;
            uint32_t rx_start1:               1;
            uint32_t tx_start1:               1;
            uint32_t rx_udf1:                 1;
            uint32_t tx_ovf1:                 1;
            uint32_t token0_1to01:            1;
            uint32_t token1_1to01:            1;
            uint32_t tx_done1:                1;
            uint32_t tx_suc_eof1:             1;
            uint32_t rx_done1:                1;
            uint32_t rx_eof1:                 1;
            uint32_t tohost1:                 1;
            uint32_t tx_dscr_err1:            1;
            uint32_t rx_dscr_err1:            1;
            uint32_t tx_dscr_empty1:          1;
            uint32_t host_rd_ack1:            1;
            uint32_t wr_retry_done1:          1;
            uint32_t tx_err_eof1:             1;
            uint32_t cmd_dtc1:                1;
            uint32_t rx_quick_eof1:           1;
            uint32_t reserved27:              5;
        };
        uint32_t val;
    } slc0_int_st1;
    union {
        struct {
            uint32_t frhost_bit01:             1;
            uint32_t frhost_bit11:             1;
            uint32_t frhost_bit21:             1;
            uint32_t frhost_bit31:             1;
            uint32_t frhost_bit41:             1;
            uint32_t frhost_bit51:             1;
            uint32_t frhost_bit61:             1;
            uint32_t frhost_bit71:             1;
            uint32_t rx_start1:                1;
            uint32_t tx_start1:                1;
            uint32_t rx_udf1:                  1;
            uint32_t tx_ovf1:                  1;
            uint32_t token0_1to01:             1;
            uint32_t token1_1to01:             1;
            uint32_t tx_done1:                 1;
            uint32_t tx_suc_eof1:              1;
            uint32_t rx_done1:                 1;
            uint32_t rx_eof1:                  1;
            uint32_t tohost1:                  1;
            uint32_t tx_dscr_err1:             1;
            uint32_t rx_dscr_err1:             1;
            uint32_t tx_dscr_empty1:           1;
            uint32_t host_rd_ack1:             1;
            uint32_t wr_retry_done1:           1;
            uint32_t tx_err_eof1:              1;
            uint32_t cmd_dtc1:                 1;
            uint32_t rx_quick_eof1:            1;
            uint32_t reserved27:               5;
        };
        uint32_t val;
    } slc0_int_ena1;
    union {
        struct {
            uint32_t frhost_bit81:            1;
            uint32_t frhost_bit91:            1;
            uint32_t frhost_bit101:           1;
            uint32_t frhost_bit111:           1;
            uint32_t frhost_bit121:           1;
            uint32_t frhost_bit131:           1;
            uint32_t frhost_bit141:           1;
            uint32_t frhost_bit151:           1;
            uint32_t rx_start1:               1;
            uint32_t tx_start1:               1;
            uint32_t rx_udf1:                 1;
            uint32_t tx_ovf1:                 1;
            uint32_t token0_1to01:            1;
            uint32_t token1_1to01:            1;
            uint32_t tx_done1:                1;
            uint32_t tx_suc_eof1:             1;
            uint32_t rx_done1:                1;
            uint32_t rx_eof1:                 1;
            uint32_t tohost1:                 1;
            uint32_t tx_dscr_err1:            1;
            uint32_t rx_dscr_err1:            1;
            uint32_t tx_dscr_empty1:          1;
            uint32_t host_rd_ack1:            1;
            uint32_t wr_retry_done1:          1;
            uint32_t tx_err_eof1:             1;
            uint32_t reserved25:              7;
        };
        uint32_t val;
    } slc1_int_st1;
    union {
        struct {
            uint32_t frhost_bit81:             1;
            uint32_t frhost_bit91:             1;
            uint32_t frhost_bit101:            1;
            uint32_t frhost_bit111:            1;
            uint32_t frhost_bit121:            1;
            uint32_t frhost_bit131:            1;
            uint32_t frhost_bit141:            1;
            uint32_t frhost_bit151:            1;
            uint32_t rx_start1:                1;
            uint32_t tx_start1:                1;
            uint32_t rx_udf1:                  1;
            uint32_t tx_ovf1:                  1;
            uint32_t token0_1to01:             1;
            uint32_t token1_1to01:             1;
            uint32_t tx_done1:                 1;
            uint32_t tx_suc_eof1:              1;
            uint32_t rx_done1:                 1;
            uint32_t rx_eof1:                  1;
            uint32_t tohost1:                  1;
            uint32_t tx_dscr_err1:             1;
            uint32_t rx_dscr_err1:             1;
            uint32_t tx_dscr_empty1:           1;
            uint32_t host_rd_ack1:             1;
            uint32_t wr_retry_done1:           1;
            uint32_t tx_err_eof1:              1;
            uint32_t reserved25:               7;
        };
        uint32_t val;
    } slc1_int_ena1;
    uint32_t reserved_14c;
    uint32_t reserved_150;
    uint32_t reserved_154;
    uint32_t reserved_158;
    uint32_t reserved_15c;
    uint32_t reserved_160;
    uint32_t reserved_164;
    uint32_t reserved_168;
    uint32_t reserved_16c;
    uint32_t reserved_170;
    uint32_t reserved_174;
    uint32_t reserved_178;
    uint32_t reserved_17c;
    uint32_t reserved_180;
    uint32_t reserved_184;
    uint32_t reserved_188;
    uint32_t reserved_18c;
    uint32_t reserved_190;
    uint32_t reserved_194;
    uint32_t reserved_198;
    uint32_t reserved_19c;
    uint32_t reserved_1a0;
    uint32_t reserved_1a4;
    uint32_t reserved_1a8;
    uint32_t reserved_1ac;
    uint32_t reserved_1b0;
    uint32_t reserved_1b4;
    uint32_t reserved_1b8;
    uint32_t reserved_1bc;
    uint32_t reserved_1c0;
    uint32_t reserved_1c4;
    uint32_t reserved_1c8;
    uint32_t reserved_1cc;
    uint32_t reserved_1d0;
    uint32_t reserved_1d4;
    uint32_t reserved_1d8;
    uint32_t reserved_1dc;
    uint32_t reserved_1e0;
    uint32_t reserved_1e4;
    uint32_t reserved_1e8;
    uint32_t reserved_1ec;
    uint32_t reserved_1f0;
    uint32_t reserved_1f4;
    uint32_t date;                                      /**/
    uint32_t id;                                        /**/
} slc_dev_t;
extern slc_dev_t SLC;

#ifdef __cplusplus
}
#endif

#endif  /* _SOC_SLC_STRUCT_H_ */`,
    spi_dev_t: `
// Copyright 2015-2016 Espressif Systems (Shanghai) PTE LTD
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at

//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
#ifndef _SOC_SPI_STRUCT_H_
#define _SOC_SPI_STRUCT_H_

#include <stdint.h>

#ifdef __cplusplus
extern "C" {
#endif

typedef volatile struct spi_dev_s {
    union {
        struct {
            uint32_t reserved0: 16;                         /*reserved*/
            uint32_t flash_per:  1;                         /*program erase resume bit  program erase suspend operation will be triggered when the bit is set. The bit will be cleared once the operation done.1: enable 0: disable.*/
            uint32_t flash_pes:  1;                         /*program erase suspend bit  program erase suspend operation will be triggered when the bit is set. The bit will be cleared once the operation done.1: enable 0: disable.*/
            uint32_t usr:        1;                         /*User define command enable.  An operation will be triggered when the bit is set. The bit will be cleared once the operation done.1: enable 0: disable.*/
            uint32_t flash_hpm:  1;                         /*Drive Flash into high performance mode.  The bit will be cleared once the operation done.1: enable 0: disable.*/
            uint32_t flash_res:  1;                         /*This bit combined with reg_resandres bit releases Flash from the power-down state or high performance mode and obtains the devices ID. The bit will be cleared once the operation done.1: enable 0: disable.*/
            uint32_t flash_dp:   1;                         /*Drive Flash into power down.  An operation will be triggered when the bit is set. The bit will be cleared once the operation done.1: enable 0: disable.*/
            uint32_t flash_ce:   1;                         /*Chip erase enable. Chip erase operation will be triggered when the bit is set. The bit will be cleared once the operation done.1: enable 0: disable.*/
            uint32_t flash_be:   1;                         /*Block erase enable(32KB) .  Block erase operation will be triggered when the bit is set. The bit will be cleared once the operation done.1: enable 0: disable.*/
            uint32_t flash_se:   1;                         /*Sector erase enable(4KB). Sector erase operation will be triggered when the bit is set. The bit will be cleared once the operation done.1: enable 0: disable.*/
            uint32_t flash_pp:   1;                         /*Page program enable(1 byte ~256 bytes data to be programmed). Page program operation  will be triggered when the bit is set. The bit will be cleared once the operation done .1: enable 0: disable.*/
            uint32_t flash_wrsr: 1;                         /*Write status register enable.   Write status operation  will be triggered when the bit is set. The bit will be cleared once the operation done.1: enable 0: disable.*/
            uint32_t flash_rdsr: 1;                         /*Read status register-1.  Read status operation will be triggered when the bit is set. The bit will be cleared once the operation done.1: enable 0: disable.*/
            uint32_t flash_rdid: 1;                         /*Read JEDEC ID . Read ID command will be sent when the bit is set. The bit will be cleared once the operation done. 1: enable 0: disable.*/
            uint32_t flash_wrdi: 1;                         /*Write flash disable. Write disable command will be sent when the bit is set. The bit will be cleared once the operation done. 1: enable 0: disable.*/
            uint32_t flash_wren: 1;                         /*Write flash enable.  Write enable command will be sent when the bit is set. The bit will be cleared once the operation done. 1: enable 0: disable.*/
            uint32_t flash_read: 1;                         /*Read flash enable. Read flash operation will be triggered when the bit is set. The bit will be cleared once the operation done. 1: enable 0: disable.*/
        };
        uint32_t val;
    } cmd;
    uint32_t addr;                                          /*addr to slave / from master. SPI transfer from the MSB to the LSB. If length > 32 bits, then address continues from MSB of slv_wr_status.*/
    union {
        struct {
            uint32_t reserved0:         10;                 /*reserved*/
            uint32_t fcs_crc_en:         1;                 /*For SPI1  initialize crc32 module before writing encrypted data to flash. Active low.*/
            uint32_t tx_crc_en:          1;                 /*For SPI1  enable crc32 when writing encrypted data to flash. 1: enable  0:disable*/
            uint32_t wait_flash_idle_en: 1;                 /*wait flash idle when program flash or erase flash. 1: enable 0: disable.*/
            uint32_t fastrd_mode:        1;                 /*This bit enable the bits: spi_fread_qio  spi_fread_dio  spi_fread_qout and spi_fread_dout. 1: enable 0: disable.*/
            uint32_t fread_dual:         1;                 /*In the read operations  read-data phase apply 2 signals. 1: enable 0: disable.*/
            uint32_t resandres:          1;                 /*The Device ID is read out to SPI_RD_STATUS register, this bit combine with spi_flash_res bit. 1: enable 0: disable.*/
            uint32_t reserved16:         4;                 /*reserved*/
            uint32_t fread_quad:         1;                 /*In the read operations read-data phase apply 4 signals. 1: enable 0: disable.*/
            uint32_t wp:                 1;                 /*Write protect signal output when SPI is idle.  1: output high  0: output low.*/
            uint32_t wrsr_2b:            1;                 /*two bytes data will be written to status register when it is set. 1: enable 0: disable.*/
            uint32_t fread_dio:          1;                 /*In the read operations address phase and read-data phase apply 2 signals. 1: enable 0: disable.*/
            uint32_t fread_qio:          1;                 /*In the read operations address phase and read-data phase apply 4 signals. 1: enable 0: disable.*/
            uint32_t rd_bit_order:       1;                 /*In read-data (MISO) phase 1: LSB first 0: MSB first*/
            uint32_t wr_bit_order:       1;                 /*In command address write-data (MOSI) phases 1: LSB firs 0: MSB first*/
            uint32_t reserved27:         5;                 /*reserved*/
        };
        uint32_t val;
    } ctrl;
    union {
        struct {
            uint32_t reserved0:        16;                  /*reserved*/
            uint32_t cs_hold_delay_res:12;                  /*Delay cycles of resume Flash when resume Flash is enable by spi clock.*/
            uint32_t cs_hold_delay:     4;                  /*SPI cs signal is delayed by spi clock cycles*/
        };
        uint32_t val;
    } ctrl1;
    union {
        struct {
            uint32_t status:    16;                         /*In the slave mode, it is the status for master to read out.*/
            uint32_t wb_mode:    8;                         /*Mode bits in the flash fast read mode, it is combined with spi_fastrd_mode bit.*/
            uint32_t status_ext: 8;                         /*In the slave mode,it is the status for master to read out.*/
        };
        uint32_t val;
    } rd_status;
    union {
        struct {
            uint32_t setup_time:       4;                   /*(cycles-1) of ,prepare, phase by spi clock, this bits combined with spi_cs_setup bit.*/
            uint32_t hold_time:        4;                   /*delay cycles of cs pin by spi clock, this bits combined with spi_cs_hold bit.*/
            uint32_t ck_out_low_mode:  4;                   /*modify spi clock duty ratio when the value is lager than 8, the bits are combined with spi_clkcnt_N bits and spi_clkcnt_L bits.*/
            uint32_t ck_out_high_mode: 4;                   /*modify spi clock duty ratio when the value is lager than 8, the bits are combined with spi_clkcnt_N bits and spi_clkcnt_H bits.*/
            uint32_t miso_delay_mode:  2;                   /*MISO signals are delayed by spi_clk. 0: zero  1: if spi_ck_out_edge or spi_ck_i_edge is set 1  delayed by half cycle    else delayed by one cycle  2: if spi_ck_out_edge or spi_ck_i_edge is set 1  delayed by one cycle  else delayed by half cycle  3: delayed one cycle*/
            uint32_t miso_delay_num:   3;                   /*MISO signals are delayed by system clock cycles*/
            uint32_t mosi_delay_mode:  2;                   /*MOSI signals are delayed by spi_clk. 0: zero  1: if spi_ck_out_edge or spi_ck_i_edge is set 1  delayed by half cycle    else delayed by one cycle  2: if spi_ck_out_edge or spi_ck_i_edge is set 1  delayed by one cycle  else delayed by half cycle  3: delayed one cycle*/
            uint32_t mosi_delay_num:   3;                   /*MOSI signals are delayed by system clock cycles*/
            uint32_t cs_delay_mode:    2;                   /*spi_cs signal is delayed by spi_clk . 0: zero  1: if spi_ck_out_edge or spi_ck_i_edge is set 1  delayed by half cycle    else delayed by one cycle  2: if spi_ck_out_edge or spi_ck_i_edge is set 1  delayed by one cycle   else delayed by half cycle  3: delayed one cycle*/
            uint32_t cs_delay_num:     4;                   /*spi_cs signal is delayed by system clock cycles*/
        };
        uint32_t val;
    } ctrl2;
    union {
        struct {
            uint32_t clkcnt_l:       6;                     /*In the master mode it must be equal to spi_clkcnt_N. In the slave mode it must be 0.*/
            uint32_t clkcnt_h:       6;                     /*In the master mode it must be floor((spi_clkcnt_N+1)/2-1). In the slave mode it must be 0.*/
            uint32_t clkcnt_n:       6;                     /*In the master mode it is the divider of spi_clk. So spi_clk frequency is system/(spi_clkdiv_pre+1)/(spi_clkcnt_N+1)*/
            uint32_t clkdiv_pre:    13;                     /*In the master mode it is pre-divider of spi_clk.*/
            uint32_t clk_equ_sysclk: 1;                     /*In the master mode 1: spi_clk is eqaul to system 0: spi_clk is divided from system clock.*/
        };
        uint32_t val;
    } clock;
    union {
        struct {
            uint32_t doutdin:           1;                  /*Set the bit to enable full duplex communication. 1: enable 0: disable.*/
            uint32_t reserved1:         3;                  /*reserved*/
            uint32_t cs_hold:           1;                  /*spi cs keep low when spi is in ,done, phase. 1: enable 0: disable.*/
            uint32_t cs_setup:          1;                  /*spi cs is enable when spi is in ,prepare, phase. 1: enable 0: disable.*/
            uint32_t ck_i_edge:         1;                  /*In the slave mode  the bit is same as spi_ck_out_edge in master mode. It is combined with  spi_miso_delay_mode bits.*/
            uint32_t ck_out_edge:       1;                  /*the bit combined with spi_mosi_delay_mode bits to set mosi signal delay mode.*/
            uint32_t reserved8:         2;                  /*reserved*/
            uint32_t rd_byte_order:     1;                  /*In read-data (MISO) phase 1: big-endian 0: little_endian*/
            uint32_t wr_byte_order:     1;                  /*In command address write-data (MOSI) phases 1: big-endian 0: litte_endian*/
            uint32_t fwrite_dual:       1;                  /*In the write operations read-data phase apply 2 signals*/
            uint32_t fwrite_quad:       1;                  /*In the write operations read-data phase apply 4 signals*/
            uint32_t fwrite_dio:        1;                  /*In the write operations address phase and read-data phase apply 2 signals.*/
            uint32_t fwrite_qio:        1;                  /*In the write operations address phase and read-data phase apply 4 signals.*/
            uint32_t sio:               1;                  /*Set the bit to enable 3-line half duplex communication  mosi and miso signals share the same pin. 1: enable 0: disable.*/
            uint32_t usr_hold_pol:      1;                  /*It is combined with hold bits to set the polarity of spi hold line  1: spi will be held when spi hold line is high  0: spi will be held when spi hold line is low*/
            uint32_t usr_dout_hold:     1;                  /*spi is hold at data out state  the bit combined with spi_usr_hold_pol bit.*/
            uint32_t usr_din_hold:      1;                  /*spi is hold at data in state  the bit combined with spi_usr_hold_pol bit.*/
            uint32_t usr_dummy_hold:    1;                  /*spi is hold at dummy state  the bit combined with spi_usr_hold_pol bit.*/
            uint32_t usr_addr_hold:     1;                  /*spi is hold at address state  the bit combined with spi_usr_hold_pol bit.*/
            uint32_t usr_cmd_hold:      1;                  /*spi is hold at command state  the bit combined with spi_usr_hold_pol bit.*/
            uint32_t usr_prep_hold:     1;                  /*spi is hold at prepare state  the bit combined with spi_usr_hold_pol bit.*/
            uint32_t usr_miso_highpart: 1;                  /*read-data phase only access to high-part of the buffer spi_w8~spi_w15. 1: enable 0: disable.*/
            uint32_t usr_mosi_highpart: 1;                  /*write-data phase only access to high-part of the buffer spi_w8~spi_w15. 1: enable 0: disable.*/
            uint32_t usr_dummy_idle:    1;                  /*spi clock is disable in dummy phase when the bit is enable.*/
            uint32_t usr_mosi:          1;                  /*This bit enable the write-data phase of an operation.*/
            uint32_t usr_miso:          1;                  /*This bit enable the read-data phase of an operation.*/
            uint32_t usr_dummy:         1;                  /*This bit enable the dummy phase of an operation.*/
            uint32_t usr_addr:          1;                  /*This bit enable the address phase of an operation.*/
            uint32_t usr_command:       1;                  /*This bit enable the command phase of an operation.*/
        };
        uint32_t val;
    } user;
    union {
        struct {
            uint32_t usr_dummy_cyclelen: 8;                 /*The length in spi_clk cycles of dummy phase. The register value shall be (cycle_num-1).*/
            uint32_t reserved8:         18;                 /*reserved*/
            uint32_t usr_addr_bitlen:    6;                 /*The length in bits of address phase. The register value shall be (bit_num-1).*/
        };
        uint32_t val;
    } user1;
    union {
        struct {
            uint32_t usr_command_value: 16;                 /*The value of  command. Output sequence: bit 7-0 and then 15-8.*/
            uint32_t reserved16:        12;                 /*reserved*/
            uint32_t usr_command_bitlen: 4;                 /*The length in bits of command phase. The register value shall be (bit_num-1)*/
        };
        uint32_t val;
    } user2;
    union {
        struct {
            uint32_t usr_mosi_dbitlen:24;                   /*The length in bits of write-data. The register value shall be (bit_num-1).*/
            uint32_t reserved24:       8;                   /*reserved*/
        };
        uint32_t val;
    } mosi_dlen;
    union {
        struct {
            uint32_t usr_miso_dbitlen:24;                   /*The length in bits of  read-data. The register value shall be (bit_num-1).*/
            uint32_t reserved24:       8;                   /*reserved*/
        };
        uint32_t val;
    } miso_dlen;
    uint32_t slv_wr_status;                                 /*In the slave mode this register are the status register for the master to write into. In the master mode this register are the higher 32bits in the 64 bits address condition.*/
    union {
        struct {
            uint32_t cs0_dis:        1;                     /*SPI CS0 pin enable, 1: disable CS0, 0: spi_cs0 signal is from/to CS0 pin*/
            uint32_t cs1_dis:        1;                     /*SPI CS1 pin enable, 1: disable CS1, 0: spi_cs1 signal is from/to CS1 pin*/
            uint32_t cs2_dis:        1;                     /*SPI CS2 pin enable, 1: disable CS2, 0: spi_cs2 signal is from/to CS2 pin*/
            uint32_t reserved3:      2;                     /*reserved*/
            uint32_t ck_dis:         1;                     /*1: spi clk out disable  0: spi clk out enable*/
            uint32_t master_cs_pol:  3;                     /*In the master mode  the bits are the polarity of spi cs line  the value is equivalent to spi_cs ^ spi_master_cs_pol.*/
            uint32_t reserved9:      2;                     /*reserved*/
            uint32_t master_ck_sel:  3;                     /*In the master mode  spi cs line is enable as spi clk  it is combined with spi_cs0_dis spi_cs1_dis spi_cs2_dis.*/
            uint32_t reserved14:    15;                     /*reserved*/
            uint32_t ck_idle_edge:   1;                     /*1: spi clk line is high when idle     0: spi clk line is low when idle*/
            uint32_t cs_keep_active: 1;                     /*spi cs line keep low when the bit is set.*/
            uint32_t reserved31:     1;                     /*reserved*/
        };
        uint32_t val;
    } pin;
    union {
        struct {
            uint32_t rd_buf_done:  1;                       /*The interrupt raw bit for the completion of read-buffer operation in the slave mode.*/
            uint32_t wr_buf_done:  1;                       /*The interrupt raw bit for the completion of write-buffer operation in the slave mode.*/
            uint32_t rd_sta_done:  1;                       /*The interrupt raw bit for the completion of read-status operation in the slave mode.*/
            uint32_t wr_sta_done:  1;                       /*The interrupt raw bit for the completion of write-status operation in the slave mode.*/
            uint32_t trans_done:   1;                       /*The interrupt raw bit for the completion of any operation in both the master mode and the slave mode.*/
            uint32_t rd_buf_inten: 1;                       /*The interrupt enable bit for the completion of read-buffer operation in the slave mode.*/
            uint32_t wr_buf_inten: 1;                       /*The interrupt enable bit for the completion of write-buffer operation in the slave mode.*/
            uint32_t rd_sta_inten: 1;                       /*The interrupt enable bit for the completion of read-status operation in the slave mode.*/
            uint32_t wr_sta_inten: 1;                       /*The interrupt enable bit for the completion of write-status operation in the slave mode.*/
            uint32_t trans_inten:  1;                       /*The interrupt enable bit for the completion of any operation in both the master mode and the slave mode.*/
            uint32_t cs_i_mode:    2;                       /*In the slave mode  this bits used to synchronize the input spi cs signal and eliminate spi cs  jitter.*/
            uint32_t reserved12:   5;                       /*reserved*/
            uint32_t last_command: 3;                       /*In the slave mode it is the value of command.*/
            uint32_t last_state:   3;                       /*In the slave mode it is the state of spi state machine.*/
            uint32_t trans_cnt:    4;                       /*The operations counter in both the master mode and the slave mode. 4: read-status*/
            uint32_t cmd_define:   1;                       /*1: slave mode commands are defined in SPI_SLAVE3.  0: slave mode commands are fixed as: 1: write-status 2: write-buffer and 3: read-buffer.*/
            uint32_t wr_rd_sta_en: 1;                       /*write and read status enable  in the slave mode*/
            uint32_t wr_rd_buf_en: 1;                       /*write and read buffer enable in the slave mode*/
            uint32_t slave_mode:   1;                       /*1: slave mode 0: master mode.*/
            uint32_t sync_reset:   1;                       /*Software reset enable, reset the spi clock line cs line and data lines.*/
        };
        uint32_t val;
    } slave;
    union {
        struct {
            uint32_t rdbuf_dummy_en:  1;                    /*In the slave mode it is the enable bit of dummy phase for read-buffer operations.*/
            uint32_t wrbuf_dummy_en:  1;                    /*In the slave mode it is the enable bit of dummy phase for write-buffer operations.*/
            uint32_t rdsta_dummy_en:  1;                    /*In the slave mode it is the enable bit of dummy phase for read-status operations.*/
            uint32_t wrsta_dummy_en:  1;                    /*In the slave mode it is the enable bit of dummy phase for write-status operations.*/
            uint32_t wr_addr_bitlen:  6;                    /*In the slave mode it is the address length in bits for write-buffer operation. The register value shall be (bit_num-1).*/
            uint32_t rd_addr_bitlen:  6;                    /*In the slave mode it is the address length in bits for read-buffer operation. The register value shall be (bit_num-1).*/
            uint32_t reserved16:      9;                    /*reserved*/
            uint32_t status_readback: 1;                    /*In the slave mode  1:read register of SPI_SLV_WR_STATUS  0: read register of SPI_RD_STATUS.*/
            uint32_t status_fast_en:  1;                    /*In the slave mode enable fast read status.*/
            uint32_t status_bitlen:   5;                    /*In the slave mode it is the length of status bit.*/
        };
        uint32_t val;
    } slave1;
    union {
        struct {
            uint32_t rdsta_dummy_cyclelen: 8;               /*In the slave mode it is the length in spi_clk cycles of dummy phase for read-status operations. The register value shall be (cycle_num-1).*/
            uint32_t wrsta_dummy_cyclelen: 8;               /*In the slave mode it is the length in spi_clk cycles of dummy phase for write-status operations. The register value shall be (cycle_num-1).*/
            uint32_t rdbuf_dummy_cyclelen: 8;               /*In the slave mode it is the length in spi_clk cycles of dummy phase for read-buffer operations. The register value shall be (cycle_num-1).*/
            uint32_t wrbuf_dummy_cyclelen: 8;               /*In the slave mode it is the length in spi_clk cycles of dummy phase for write-buffer operations. The register value shall be (cycle_num-1).*/
        };
        uint32_t val;
    } slave2;
    union {
        struct {
            uint32_t rdbuf_cmd_value: 8;                    /*In the slave mode it is the value of read-buffer command.*/
            uint32_t wrbuf_cmd_value: 8;                    /*In the slave mode it is the value of write-buffer command.*/
            uint32_t rdsta_cmd_value: 8;                    /*In the slave mode it is the value of read-status command.*/
            uint32_t wrsta_cmd_value: 8;                    /*In the slave mode it is the value of write-status command.*/
        };
        uint32_t val;
    } slave3;
    union {
        struct {
            uint32_t bit_len:    24;                        /*In the slave mode it is the length in bits for write-buffer operations. The register value shall be (bit_num-1).*/
            uint32_t reserved24:  8;                        /*reserved*/
        };
        uint32_t val;
    } slv_wrbuf_dlen;
    union {
        struct {
            uint32_t bit_len:    24;                        /*In the slave mode it is the length in bits for read-buffer operations. The register value shall be (bit_num-1).*/
            uint32_t reserved24:  8;                        /*reserved*/
        };
        uint32_t val;
    } slv_rdbuf_dlen;
    union {
        struct {
            uint32_t req_en:        1;                      /*For SPI0  Cache access enable  1: enable  0:disable.*/
            uint32_t usr_cmd_4byte: 1;                      /*For SPI0  cache  read flash with 4 bytes command  1: enable  0:disable.*/
            uint32_t flash_usr_cmd: 1;                      /*For SPI0  cache  read flash for user define command  1: enable  0:disable.*/
            uint32_t flash_pes_en:  1;                      /*For SPI0  spi1 send suspend command before cache read flash  1: enable  0:disable.*/
            uint32_t reserved4:    28;                      /*reserved*/
        };
        uint32_t val;
    } cache_fctrl;
    union {
        struct {
            uint32_t reserved0:           1;                /*reserved*/
            uint32_t usr_sram_dio:        1;                /*For SPI0  In the spi sram mode  spi dual I/O mode enable  1: enable  0:disable*/
            uint32_t usr_sram_qio:        1;                /*For SPI0  In the spi sram mode  spi quad I/O mode enable  1: enable  0:disable*/
            uint32_t usr_wr_sram_dummy:   1;                /*For SPI0  In the spi sram mode  it is the enable bit of dummy phase for write operations.*/
            uint32_t usr_rd_sram_dummy:   1;                /*For SPI0  In the spi sram mode  it is the enable bit of dummy phase for read operations.*/
            uint32_t cache_sram_usr_rcmd: 1;                /*For SPI0  In the spi sram mode cache read sram for user define command.*/
            uint32_t sram_bytes_len:      8;                /*For SPI0  In the sram mode  it is the byte length of spi read sram data.*/
            uint32_t sram_dummy_cyclelen: 8;                /*For SPI0  In the sram mode  it is the length in bits of address phase. The register value shall be (bit_num-1).*/
            uint32_t sram_addr_bitlen:    6;                /*For SPI0  In the sram mode  it is the length in bits of address phase. The register value shall be (bit_num-1).*/
            uint32_t cache_sram_usr_wcmd: 1;                /*For SPI0  In the spi sram mode cache write sram for user define command*/
            uint32_t reserved29:          3;                /*reserved*/
        };
        uint32_t val;
    } cache_sctrl;
    union {
        struct {
            uint32_t dio:       1;                          /*For SPI0 SRAM DIO mode enable .  SRAM DIO enable command will be send when the bit is set. The bit will be cleared once the operation done.*/
            uint32_t qio:       1;                          /*For SPI0 SRAM QIO mode enable .  SRAM QIO enable command will be send when the bit is set. The bit will be cleared once the operation done.*/
            uint32_t reserved2: 2;                          /*For SPI0 SRAM write enable . SRAM write operation will be triggered when the bit is set. The bit will be cleared once the operation done.*/
            uint32_t rst_io:    1;                          /*For SPI0 SRAM IO mode reset enable. SRAM IO mode reset operation will be triggered when the bit is set. The bit will be cleared once the operation done*/
            uint32_t reserved5:27;                          /*reserved*/
        };
        uint32_t val;
    } sram_cmd;
    union {
        struct {
            uint32_t usr_rd_cmd_value:   16;                /*For SPI0 When cache mode is enable it is the read command value of command phase for SRAM.*/
            uint32_t reserved16:         12;                /*reserved*/
            uint32_t usr_rd_cmd_bitlen:   4;                /*For SPI0 When cache mode is enable it is the length in bits of command phase for SRAM. The register value shall be (bit_num-1).*/
        };
        uint32_t val;
    } sram_drd_cmd;
    union {
        struct {
            uint32_t usr_wr_cmd_value: 16;                  /*For SPI0 When cache mode is enable it is the write command value of command phase for SRAM.*/
            uint32_t reserved16:       12;                  /*reserved*/
            uint32_t usr_wr_cmd_bitlen: 4;                  /*For SPI0 When cache mode is enable it is the in bits of command phase  for SRAM. The register value shall be (bit_num-1).*/
        };
        uint32_t val;
    } sram_dwr_cmd;
    union {
        struct {
            uint32_t slv_rdata_bit:24;                      /*In the slave mode it is the bit length of read data. The value is the length - 1.*/
            uint32_t reserved24:    8;                      /*reserved*/
        };
        uint32_t val;
    } slv_rd_bit;
    uint32_t reserved_68;
    uint32_t reserved_6c;
    uint32_t reserved_70;
    uint32_t reserved_74;
    uint32_t reserved_78;
    uint32_t reserved_7c;
    uint32_t data_buf[16];                                  /*data buffer*/
    uint32_t tx_crc;                                        /*For SPI1  the value of crc32 for 256 bits data.*/
    uint32_t reserved_c4;
    uint32_t reserved_c8;
    uint32_t reserved_cc;
    uint32_t reserved_d0;
    uint32_t reserved_d4;
    uint32_t reserved_d8;
    uint32_t reserved_dc;
    uint32_t reserved_e0;
    uint32_t reserved_e4;
    uint32_t reserved_e8;
    uint32_t reserved_ec;
    union {
        struct {
            uint32_t t_pp_time: 12;                         /*page program delay time  by system clock.*/
            uint32_t reserved12: 4;                         /*reserved*/
            uint32_t t_pp_shift: 4;                         /*page program delay time shift .*/
            uint32_t reserved20:11;                         /*reserved*/
            uint32_t t_pp_ena:   1;                         /*page program delay enable.*/
        };
        uint32_t val;
    } ext0;
    union {
        struct {
            uint32_t t_erase_time: 12;                      /*erase flash delay time by system clock.*/
            uint32_t reserved12:    4;                      /*reserved*/
            uint32_t t_erase_shift: 4;                      /*erase flash delay time shift.*/
            uint32_t reserved20:   11;                      /*reserved*/
            uint32_t t_erase_ena:   1;                      /*erase flash delay enable.*/
        };
        uint32_t val;
    } ext1;
    union {
        struct {
            uint32_t st:         3;                         /*The status of spi state machine .*/
            uint32_t reserved3: 29;                         /*reserved*/
        };
        uint32_t val;
    } ext2;
    union {
        struct {
            uint32_t int_hold_ena: 2;                       /*This register is for two SPI masters to share the same cs clock and data signals. The bits of one SPI are set  if the other SPI is busy  the SPI will be hold. 1(3): hold at ,idle, phase 2: hold at ,prepare, phase.*/
            uint32_t reserved2:   30;                       /*reserved*/
        };
        uint32_t val;
    } ext3;
    union {
        struct {
            uint32_t reserved0:         2;                  /*reserved*/
            uint32_t in_rst:            1;                  /*The bit is used to reset in dma fsm and in data fifo pointer.*/
            uint32_t out_rst:           1;                  /*The bit is used to reset out dma fsm and out data fifo pointer.*/
            uint32_t ahbm_fifo_rst:     1;                  /*reset spi dma ahb master fifo pointer.*/
            uint32_t ahbm_rst:          1;                  /*reset spi dma ahb master.*/
            uint32_t in_loop_test:      1;                  /*Set bit to test in link.*/
            uint32_t out_loop_test:     1;                  /*Set bit to test out link.*/
            uint32_t out_auto_wrback:   1;                  /*when the link is empty   jump to next automatically.*/
            uint32_t out_eof_mode:      1;                  /*out eof flag generation mode . 1: when dma pop all data from fifo  0:when ahb push all data to fifo.*/
            uint32_t outdscr_burst_en:  1;                  /*read descriptor use burst mode when read data for memory.*/
            uint32_t indscr_burst_en:   1;                  /*read descriptor use burst mode when write data to memory.*/
            uint32_t out_data_burst_en: 1;                  /*spi dma read data from memory in burst mode.*/
            uint32_t reserved13:        1;                  /*reserved*/
            uint32_t dma_rx_stop:       1;                  /*spi dma read data stop  when in continue tx/rx mode.*/
            uint32_t dma_tx_stop:       1;                  /*spi dma write data stop when in continue tx/rx mode.*/
            uint32_t dma_continue:      1;                  /*spi dma continue tx/rx data.*/
            uint32_t reserved17:       15;                  /*reserved*/
        };
        uint32_t val;
    } dma_conf;
    union {
        struct {
            uint32_t addr:        20;                       /*The address of the first outlink descriptor.*/
            uint32_t reserved20:   8;                       /*reserved*/
            uint32_t stop:         1;                       /*Set the bit to stop to use outlink descriptor.*/
            uint32_t start:        1;                       /*Set the bit to start to use outlink descriptor.*/
            uint32_t restart:      1;                       /*Set the bit to mount on new outlink descriptors.*/
            uint32_t reserved31:   1;                       /*reserved*/
        };
        uint32_t val;
    } dma_out_link;
    union {
        struct {
            uint32_t addr:       20;                        /*The address of the first inlink descriptor.*/
            uint32_t auto_ret:    1;                        /*when the bit is set  inlink descriptor returns to the next descriptor while a packet is wrong*/
            uint32_t reserved21:  7;                        /*reserved*/
            uint32_t stop:        1;                        /*Set the bit to stop to use inlink descriptor.*/
            uint32_t start:       1;                        /*Set the bit to start to use inlink descriptor.*/
            uint32_t restart:     1;                        /*Set the bit to mount on new inlink descriptors.*/
            uint32_t reserved31:  1;                        /*reserved*/
        };
        uint32_t val;
    } dma_in_link;
    union {
        struct {
            uint32_t rx_en:      1;                         /*spi dma read data status bit.*/
            uint32_t tx_en:      1;                         /*spi dma write data status bit.*/
            uint32_t reserved2: 30;                         /*spi dma read data from memory count.*/
        };
        uint32_t val;
    } dma_status;
    union {
        struct {
            uint32_t inlink_dscr_empty:  1;                 /*The enable bit for lack of enough inlink descriptors.*/
            uint32_t outlink_dscr_error: 1;                 /*The enable bit for outlink descriptor error.*/
            uint32_t inlink_dscr_error:  1;                 /*The enable bit for inlink descriptor error.*/
            uint32_t in_done:            1;                 /*The enable bit for completing usage of a inlink descriptor.*/
            uint32_t in_err_eof:         1;                 /*The enable bit for receiving error.*/
            uint32_t in_suc_eof:         1;                 /*The enable bit for completing receiving all the packets from host.*/
            uint32_t out_done:           1;                 /*The enable bit for completing usage of a outlink descriptor .*/
            uint32_t out_eof:            1;                 /*The enable bit for sending a packet to host done.*/
            uint32_t out_total_eof:      1;                 /*The enable bit for sending all the packets to host done.*/
            uint32_t reserved9:         23;                 /*reserved*/
        };
        uint32_t val;
    } dma_int_ena;
    union {
        struct {
            uint32_t inlink_dscr_empty:  1;                 /*The raw bit for lack of enough inlink descriptors.*/
            uint32_t outlink_dscr_error: 1;                 /*The raw bit for outlink descriptor error.*/
            uint32_t inlink_dscr_error:  1;                 /*The raw bit for inlink descriptor error.*/
            uint32_t in_done:            1;                 /*The raw bit for completing usage of a inlink descriptor.*/
            uint32_t in_err_eof:         1;                 /*The raw bit for receiving error.*/
            uint32_t in_suc_eof:         1;                 /*The raw bit for completing receiving all the packets from host.*/
            uint32_t out_done:           1;                 /*The raw bit for completing usage of a outlink descriptor.*/
            uint32_t out_eof:            1;                 /*The raw bit for sending a packet to host done.*/
            uint32_t out_total_eof:      1;                 /*The raw bit for sending all the packets to host done.*/
            uint32_t reserved9:         23;                 /*reserved*/
        };
        uint32_t val;
    } dma_int_raw;
    union {
        struct {
            uint32_t inlink_dscr_empty:  1;                  /*The status bit for lack of enough inlink descriptors.*/
            uint32_t outlink_dscr_error: 1;                  /*The status bit for outlink descriptor error.*/
            uint32_t inlink_dscr_error:  1;                  /*The status bit for inlink descriptor error.*/
            uint32_t in_done:            1;                  /*The status bit for completing usage of a inlink descriptor.*/
            uint32_t in_err_eof:         1;                  /*The status bit for receiving error.*/
            uint32_t in_suc_eof:         1;                  /*The status bit for completing receiving all the packets from host.*/
            uint32_t out_done:           1;                  /*The status bit for completing usage of a outlink descriptor.*/
            uint32_t out_eof:            1;                  /*The status bit for sending a packet to host done.*/
            uint32_t out_total_eof:      1;                  /*The status bit for sending all the packets to host done.*/
            uint32_t reserved9:         23;                  /*reserved*/
        };
        uint32_t val;
    } dma_int_st;
    union {
        struct {
            uint32_t inlink_dscr_empty:  1;                 /*The clear bit for lack of enough inlink descriptors.*/
            uint32_t outlink_dscr_error: 1;                 /*The clear bit for outlink descriptor error.*/
            uint32_t inlink_dscr_error:  1;                 /*The clear bit for inlink descriptor error.*/
            uint32_t in_done:            1;                 /*The clear bit for completing usage of a inlink descriptor.*/
            uint32_t in_err_eof:         1;                 /*The clear bit for receiving error.*/
            uint32_t in_suc_eof:         1;                 /*The clear bit for completing receiving all the packets from host.*/
            uint32_t out_done:           1;                 /*The clear bit for completing usage of a outlink descriptor.*/
            uint32_t out_eof:            1;                 /*The clear bit for sending a packet to host done.*/
            uint32_t out_total_eof:      1;                 /*The clear bit for sending all the packets to host done.*/
            uint32_t reserved9:         23;                 /*reserved*/
        };
        uint32_t val;
    } dma_int_clr;
    uint32_t dma_in_err_eof_des_addr;                       /*The inlink descriptor address when spi dma produce receiving error.*/
    uint32_t dma_in_suc_eof_des_addr;                       /*The last inlink descriptor address when spi dma produce from_suc_eof.*/
    uint32_t dma_inlink_dscr;                               /*The content of current in descriptor pointer.*/
    uint32_t dma_inlink_dscr_bf0;                           /*The content of next in descriptor pointer.*/
    uint32_t dma_inlink_dscr_bf1;                           /*The content of current in descriptor data buffer pointer.*/
    uint32_t dma_out_eof_bfr_des_addr;                      /*The address of buffer relative to the outlink descriptor that produce eof.*/
    uint32_t dma_out_eof_des_addr;                          /*The last outlink descriptor address when spi dma produce to_eof.*/
    uint32_t dma_outlink_dscr;                              /*The content of current out descriptor pointer.*/
    uint32_t dma_outlink_dscr_bf0;                          /*The content of next out descriptor pointer.*/
    uint32_t dma_outlink_dscr_bf1;                          /*The content of current out descriptor data buffer pointer.*/
    uint32_t dma_rx_status;                                 /*spi dma read data from memory status.*/
    uint32_t dma_tx_status;                                 /*spi dma write data to memory status.*/
    uint32_t reserved_150;
    uint32_t reserved_154;
    uint32_t reserved_158;
    uint32_t reserved_15c;
    uint32_t reserved_160;
    uint32_t reserved_164;
    uint32_t reserved_168;
    uint32_t reserved_16c;
    uint32_t reserved_170;
    uint32_t reserved_174;
    uint32_t reserved_178;
    uint32_t reserved_17c;
    uint32_t reserved_180;
    uint32_t reserved_184;
    uint32_t reserved_188;
    uint32_t reserved_18c;
    uint32_t reserved_190;
    uint32_t reserved_194;
    uint32_t reserved_198;
    uint32_t reserved_19c;
    uint32_t reserved_1a0;
    uint32_t reserved_1a4;
    uint32_t reserved_1a8;
    uint32_t reserved_1ac;
    uint32_t reserved_1b0;
    uint32_t reserved_1b4;
    uint32_t reserved_1b8;
    uint32_t reserved_1bc;
    uint32_t reserved_1c0;
    uint32_t reserved_1c4;
    uint32_t reserved_1c8;
    uint32_t reserved_1cc;
    uint32_t reserved_1d0;
    uint32_t reserved_1d4;
    uint32_t reserved_1d8;
    uint32_t reserved_1dc;
    uint32_t reserved_1e0;
    uint32_t reserved_1e4;
    uint32_t reserved_1e8;
    uint32_t reserved_1ec;
    uint32_t reserved_1f0;
    uint32_t reserved_1f4;
    uint32_t reserved_1f8;
    uint32_t reserved_1fc;
    uint32_t reserved_200;
    uint32_t reserved_204;
    uint32_t reserved_208;
    uint32_t reserved_20c;
    uint32_t reserved_210;
    uint32_t reserved_214;
    uint32_t reserved_218;
    uint32_t reserved_21c;
    uint32_t reserved_220;
    uint32_t reserved_224;
    uint32_t reserved_228;
    uint32_t reserved_22c;
    uint32_t reserved_230;
    uint32_t reserved_234;
    uint32_t reserved_238;
    uint32_t reserved_23c;
    uint32_t reserved_240;
    uint32_t reserved_244;
    uint32_t reserved_248;
    uint32_t reserved_24c;
    uint32_t reserved_250;
    uint32_t reserved_254;
    uint32_t reserved_258;
    uint32_t reserved_25c;
    uint32_t reserved_260;
    uint32_t reserved_264;
    uint32_t reserved_268;
    uint32_t reserved_26c;
    uint32_t reserved_270;
    uint32_t reserved_274;
    uint32_t reserved_278;
    uint32_t reserved_27c;
    uint32_t reserved_280;
    uint32_t reserved_284;
    uint32_t reserved_288;
    uint32_t reserved_28c;
    uint32_t reserved_290;
    uint32_t reserved_294;
    uint32_t reserved_298;
    uint32_t reserved_29c;
    uint32_t reserved_2a0;
    uint32_t reserved_2a4;
    uint32_t reserved_2a8;
    uint32_t reserved_2ac;
    uint32_t reserved_2b0;
    uint32_t reserved_2b4;
    uint32_t reserved_2b8;
    uint32_t reserved_2bc;
    uint32_t reserved_2c0;
    uint32_t reserved_2c4;
    uint32_t reserved_2c8;
    uint32_t reserved_2cc;
    uint32_t reserved_2d0;
    uint32_t reserved_2d4;
    uint32_t reserved_2d8;
    uint32_t reserved_2dc;
    uint32_t reserved_2e0;
    uint32_t reserved_2e4;
    uint32_t reserved_2e8;
    uint32_t reserved_2ec;
    uint32_t reserved_2f0;
    uint32_t reserved_2f4;
    uint32_t reserved_2f8;
    uint32_t reserved_2fc;
    uint32_t reserved_300;
    uint32_t reserved_304;
    uint32_t reserved_308;
    uint32_t reserved_30c;
    uint32_t reserved_310;
    uint32_t reserved_314;
    uint32_t reserved_318;
    uint32_t reserved_31c;
    uint32_t reserved_320;
    uint32_t reserved_324;
    uint32_t reserved_328;
    uint32_t reserved_32c;
    uint32_t reserved_330;
    uint32_t reserved_334;
    uint32_t reserved_338;
    uint32_t reserved_33c;
    uint32_t reserved_340;
    uint32_t reserved_344;
    uint32_t reserved_348;
    uint32_t reserved_34c;
    uint32_t reserved_350;
    uint32_t reserved_354;
    uint32_t reserved_358;
    uint32_t reserved_35c;
    uint32_t reserved_360;
    uint32_t reserved_364;
    uint32_t reserved_368;
    uint32_t reserved_36c;
    uint32_t reserved_370;
    uint32_t reserved_374;
    uint32_t reserved_378;
    uint32_t reserved_37c;
    uint32_t reserved_380;
    uint32_t reserved_384;
    uint32_t reserved_388;
    uint32_t reserved_38c;
    uint32_t reserved_390;
    uint32_t reserved_394;
    uint32_t reserved_398;
    uint32_t reserved_39c;
    uint32_t reserved_3a0;
    uint32_t reserved_3a4;
    uint32_t reserved_3a8;
    uint32_t reserved_3ac;
    uint32_t reserved_3b0;
    uint32_t reserved_3b4;
    uint32_t reserved_3b8;
    uint32_t reserved_3bc;
    uint32_t reserved_3c0;
    uint32_t reserved_3c4;
    uint32_t reserved_3c8;
    uint32_t reserved_3cc;
    uint32_t reserved_3d0;
    uint32_t reserved_3d4;
    uint32_t reserved_3d8;
    uint32_t reserved_3dc;
    uint32_t reserved_3e0;
    uint32_t reserved_3e4;
    uint32_t reserved_3e8;
    uint32_t reserved_3ec;
    uint32_t reserved_3f0;
    uint32_t reserved_3f4;
    uint32_t reserved_3f8;
    union {
        struct {
            uint32_t date:      28;                         /*SPI register version.*/
            uint32_t reserved28: 4;                         /*reserved*/
        };
        uint32_t val;
    } date;
} spi_dev_t;
extern spi_dev_t SPI0;                                      /* SPI0 IS FOR INTERNAL USE*/
extern spi_dev_t SPI1;
extern spi_dev_t SPI2;
extern spi_dev_t SPI3;

#ifdef __cplusplus
}
#endif

#endif  /* _SOC_SPI_STRUCT_H_ */`,
    i2s_dev_t: `
// Copyright 2015-2016 Espressif Systems (Shanghai) PTE LTD
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at

//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
#ifndef _SOC_I2S_STRUCT_H_
#define _SOC_I2S_STRUCT_H_

#include <stdint.h>

#ifdef __cplusplus
extern "C" {
#endif

typedef volatile struct i2s_dev_s {
    uint32_t reserved_0;
    uint32_t reserved_4;
    union {
        struct {
            uint32_t tx_reset:       1;
            uint32_t rx_reset:       1;
            uint32_t tx_fifo_reset:  1;
            uint32_t rx_fifo_reset:  1;
            uint32_t tx_start:       1;
            uint32_t rx_start:       1;
            uint32_t tx_slave_mod:   1;
            uint32_t rx_slave_mod:   1;
            uint32_t tx_right_first: 1;
            uint32_t rx_right_first: 1;
            uint32_t tx_msb_shift:   1;
            uint32_t rx_msb_shift:   1;
            uint32_t tx_short_sync:  1;
            uint32_t rx_short_sync:  1;
            uint32_t tx_mono:        1;
            uint32_t rx_mono:        1;
            uint32_t tx_msb_right:   1;
            uint32_t rx_msb_right:   1;
            uint32_t sig_loopback:   1;
            uint32_t reserved19:    13;
        };
        uint32_t val;
    } conf;
    union {
        struct {
            uint32_t rx_take_data:  1;
            uint32_t tx_put_data:   1;
            uint32_t rx_wfull:      1;
            uint32_t rx_rempty:     1;
            uint32_t tx_wfull:      1;
            uint32_t tx_rempty:     1;
            uint32_t rx_hung:       1;
            uint32_t tx_hung:       1;
            uint32_t in_done:       1;
            uint32_t in_suc_eof:    1;
            uint32_t in_err_eof:    1;
            uint32_t out_done:      1;
            uint32_t out_eof:       1;
            uint32_t in_dscr_err:   1;
            uint32_t out_dscr_err:  1;
            uint32_t in_dscr_empty: 1;
            uint32_t out_total_eof: 1;
            uint32_t reserved17:   15;
        };
        uint32_t val;
    } int_raw;
    union {
        struct {
            uint32_t rx_take_data:  1;
            uint32_t tx_put_data:   1;
            uint32_t rx_wfull:      1;
            uint32_t rx_rempty:     1;
            uint32_t tx_wfull:      1;
            uint32_t tx_rempty:     1;
            uint32_t rx_hung:       1;
            uint32_t tx_hung:       1;
            uint32_t in_done:       1;
            uint32_t in_suc_eof:    1;
            uint32_t in_err_eof:    1;
            uint32_t out_done:      1;
            uint32_t out_eof:       1;
            uint32_t in_dscr_err:   1;
            uint32_t out_dscr_err:  1;
            uint32_t in_dscr_empty: 1;
            uint32_t out_total_eof: 1;
            uint32_t reserved17:   15;
        };
        uint32_t val;
    } int_st;
    union {
        struct {
            uint32_t rx_take_data:  1;
            uint32_t tx_put_data:   1;
            uint32_t rx_wfull:      1;
            uint32_t rx_rempty:     1;
            uint32_t tx_wfull:      1;
            uint32_t tx_rempty:     1;
            uint32_t rx_hung:       1;
            uint32_t tx_hung:       1;
            uint32_t in_done:       1;
            uint32_t in_suc_eof:    1;
            uint32_t in_err_eof:    1;
            uint32_t out_done:      1;
            uint32_t out_eof:       1;
            uint32_t in_dscr_err:   1;
            uint32_t out_dscr_err:  1;
            uint32_t in_dscr_empty: 1;
            uint32_t out_total_eof: 1;
            uint32_t reserved17:   15;
        };
        uint32_t val;
    } int_ena;
    union {
        struct {
            uint32_t take_data:     1;
            uint32_t put_data:      1;
            uint32_t rx_wfull:      1;
            uint32_t rx_rempty:     1;
            uint32_t tx_wfull:      1;
            uint32_t tx_rempty:     1;
            uint32_t rx_hung:       1;
            uint32_t tx_hung:       1;
            uint32_t in_done:       1;
            uint32_t in_suc_eof:    1;
            uint32_t in_err_eof:    1;
            uint32_t out_done:      1;
            uint32_t out_eof:       1;
            uint32_t in_dscr_err:   1;
            uint32_t out_dscr_err:  1;
            uint32_t in_dscr_empty: 1;
            uint32_t out_total_eof: 1;
            uint32_t reserved17:   15;
        };
        uint32_t val;
    } int_clr;
    union {
        struct {
            uint32_t tx_bck_in_delay:   2;
            uint32_t tx_ws_in_delay:    2;
            uint32_t rx_bck_in_delay:   2;
            uint32_t rx_ws_in_delay:    2;
            uint32_t rx_sd_in_delay:    2;
            uint32_t tx_bck_out_delay:  2;
            uint32_t tx_ws_out_delay:   2;
            uint32_t tx_sd_out_delay:   2;
            uint32_t rx_ws_out_delay:   2;
            uint32_t rx_bck_out_delay:  2;
            uint32_t tx_dsync_sw:       1;
            uint32_t rx_dsync_sw:       1;
            uint32_t data_enable_delay: 2;
            uint32_t tx_bck_in_inv:     1;
            uint32_t reserved25:        7;
        };
        uint32_t val;
    } timing;
    union {
        struct {
            uint32_t rx_data_num:          6;
            uint32_t tx_data_num:          6;
            uint32_t dscr_en:              1;
            uint32_t tx_fifo_mod:          3;
            uint32_t rx_fifo_mod:          3;
            uint32_t tx_fifo_mod_force_en: 1;
            uint32_t rx_fifo_mod_force_en: 1;
            uint32_t reserved21:          11;
        };
        uint32_t val;
    } fifo_conf;
    uint32_t rx_eof_num;
    uint32_t conf_single_data;
    union {
        struct {
            uint32_t tx_chan_mod: 3;
            uint32_t rx_chan_mod: 2;
            uint32_t reserved5:  27;
        };
        uint32_t val;
    } conf_chan;
    union {
        struct {
            uint32_t addr:       20;
            uint32_t reserved20:  8;
            uint32_t stop:        1;
            uint32_t start:       1;
            uint32_t restart:     1;
            uint32_t park:        1;
        };
        uint32_t val;
    } out_link;
    union {
        struct {
            uint32_t addr:       20;
            uint32_t reserved20:  8;
            uint32_t stop:        1;
            uint32_t start:       1;
            uint32_t restart:     1;
            uint32_t park:        1;
        };
        uint32_t val;
    } in_link;
    uint32_t out_eof_des_addr;
    uint32_t in_eof_des_addr;
    uint32_t out_eof_bfr_des_addr;
    union {
        struct {
            uint32_t mode:       3;
            uint32_t reserved3:  1;
            uint32_t addr:       2;
            uint32_t reserved6: 26;
        };
        uint32_t val;
    } ahb_test;
    uint32_t in_link_dscr;
    uint32_t in_link_dscr_bf0;
    uint32_t in_link_dscr_bf1;
    uint32_t out_link_dscr;
    uint32_t out_link_dscr_bf0;
    uint32_t out_link_dscr_bf1;
    union {
        struct {
            uint32_t in_rst:             1;
            uint32_t out_rst:            1;
            uint32_t ahbm_fifo_rst:      1;
            uint32_t ahbm_rst:           1;
            uint32_t out_loop_test:      1;
            uint32_t in_loop_test:       1;
            uint32_t out_auto_wrback:    1;
            uint32_t out_no_restart_clr: 1;
            uint32_t out_eof_mode:       1;
            uint32_t outdscr_burst_en:   1;
            uint32_t indscr_burst_en:    1;
            uint32_t out_data_burst_en:  1;
            uint32_t check_owner:        1;
            uint32_t mem_trans_en:       1;
            uint32_t reserved14:        18;
        };
        uint32_t val;
    } lc_conf;
    union {
        struct {
            uint32_t wdata:      9;
            uint32_t reserved9:  7;
            uint32_t push:       1;
            uint32_t reserved17: 15;
        };
        uint32_t val;
    } out_fifo_push;
    union {
        struct {
            uint32_t rdata:      12;
            uint32_t reserved12:  4;
            uint32_t pop:         1;
            uint32_t reserved17: 15;
        };
        uint32_t val;
    } in_fifo_pop;
    uint32_t lc_state0;
    uint32_t lc_state1;
    union {
        struct {
            uint32_t fifo_timeout:       8;
            uint32_t fifo_timeout_shift: 3;
            uint32_t fifo_timeout_ena:   1;
            uint32_t reserved12:        20;
        };
        uint32_t val;
    } lc_hung_conf;
    uint32_t reserved_78;
    uint32_t reserved_7c;
    union {
        struct {
            uint32_t y_max:16;
            uint32_t y_min:16;
        };
        uint32_t val;
    } cvsd_conf0;
    union {
        struct {
            uint32_t sigma_max:16;
            uint32_t sigma_min:16;
        };
        uint32_t val;
    } cvsd_conf1;
    union {
        struct {
            uint32_t cvsd_k:     3;
            uint32_t cvsd_j:     3;
            uint32_t cvsd_beta: 10;
            uint32_t cvsd_h:     3;
            uint32_t reserved19:13;
        };
        uint32_t val;
    } cvsd_conf2;
    union {
        struct {
            uint32_t good_pack_max:    6;
            uint32_t n_err_seg:        3;
            uint32_t shift_rate:       3;
            uint32_t max_slide_sample: 8;
            uint32_t pack_len_8k:      5;
            uint32_t n_min_err:        3;
            uint32_t reserved28:       4;
        };
        uint32_t val;
    } plc_conf0;
    union {
        struct {
            uint32_t bad_cef_atten_para:       8;
            uint32_t bad_cef_atten_para_shift: 4;
            uint32_t bad_ola_win2_para_shift:  4;
            uint32_t bad_ola_win2_para:        8;
            uint32_t slide_win_len:            8;
        };
        uint32_t val;
    } plc_conf1;
    union {
        struct {
            uint32_t cvsd_seg_mod: 2;
            uint32_t min_period:   5;
            uint32_t reserved7:   25;
        };
        uint32_t val;
    } plc_conf2;
    union {
        struct {
            uint32_t en:                1;
            uint32_t chan_mod:          1;
            uint32_t cvsd_dec_pack_err: 1;
            uint32_t cvsd_pack_len_8k:  5;
            uint32_t cvsd_inf_en:       1;
            uint32_t cvsd_dec_start:    1;
            uint32_t cvsd_dec_reset:    1;
            uint32_t plc_en:            1;
            uint32_t plc2dma_en:        1;
            uint32_t reserved13:       19;
        };
        uint32_t val;
    } esco_conf0;
    union {
        struct {
            uint32_t with_en:        1;
            uint32_t no_en:          1;
            uint32_t cvsd_enc_start: 1;
            uint32_t cvsd_enc_reset: 1;
            uint32_t reserved4:     28;
        };
        uint32_t val;
    } sco_conf0;
    union {
        struct {
            uint32_t tx_pcm_conf:    3;
            uint32_t tx_pcm_bypass:  1;
            uint32_t rx_pcm_conf:    3;
            uint32_t rx_pcm_bypass:  1;
            uint32_t tx_stop_en:     1;
            uint32_t tx_zeros_rm_en: 1;
            uint32_t reserved10:    22;
        };
        uint32_t val;
    } conf1;
    union {
        struct {
            uint32_t fifo_force_pd:    1;
            uint32_t fifo_force_pu:    1;
            uint32_t plc_mem_force_pd: 1;
            uint32_t plc_mem_force_pu: 1;
            uint32_t reserved4:       28;
        };
        uint32_t val;
    } pd_conf;
    union {
        struct {
            uint32_t camera_en:           1;
            uint32_t lcd_tx_wrx2_en:      1;
            uint32_t lcd_tx_sdx2_en:      1;
            uint32_t data_enable_test_en: 1;
            uint32_t data_enable:         1;
            uint32_t lcd_en:              1;
            uint32_t ext_adc_start_en:    1;
            uint32_t inter_valid_en:      1;
            uint32_t reserved8:          24;
        };
        uint32_t val;
    } conf2;
    union {
        struct {
            uint32_t clkm_div_num: 8;
            uint32_t clkm_div_b:   6;
            uint32_t clkm_div_a:   6;
            uint32_t clk_en:       1;
            uint32_t clka_en:      1;
            uint32_t reserved22:  10;
        };
        uint32_t val;
    } clkm_conf;
    union {
        struct {
            uint32_t tx_bck_div_num: 6;
            uint32_t rx_bck_div_num: 6;
            uint32_t tx_bits_mod:    6;
            uint32_t rx_bits_mod:    6;
            uint32_t reserved24:     8;
        };
        uint32_t val;
    } sample_rate_conf;
    union {
        struct {
            uint32_t tx_pdm_en:              1;
            uint32_t rx_pdm_en:              1;
            uint32_t pcm2pdm_conv_en:        1;
            uint32_t pdm2pcm_conv_en:        1;
            uint32_t tx_sinc_osr2:           4;
            uint32_t tx_prescale:            8;
            uint32_t tx_hp_in_shift:         2;
            uint32_t tx_lp_in_shift:         2;
            uint32_t tx_sinc_in_shift:       2;
            uint32_t tx_sigmadelta_in_shift: 2;
            uint32_t rx_sinc_dsr_16_en:      1;
            uint32_t txhp_bypass:            1;
            uint32_t reserved26:             6;
        };
        uint32_t val;
    } pdm_conf;
    union {
        struct {
            uint32_t tx_pdm_fs: 10;
            uint32_t tx_pdm_fp: 10;
            uint32_t reserved20:12;
        };
        uint32_t val;
    } pdm_freq_conf;
    union {
        struct {
            uint32_t tx_idle:            1;
            uint32_t tx_fifo_reset_back: 1;
            uint32_t rx_fifo_reset_back: 1;
            uint32_t reserved3:         29;
        };
        uint32_t val;
    } state;
    uint32_t reserved_c0;
    uint32_t reserved_c4;
    uint32_t reserved_c8;
    uint32_t reserved_cc;
    uint32_t reserved_d0;
    uint32_t reserved_d4;
    uint32_t reserved_d8;
    uint32_t reserved_dc;
    uint32_t reserved_e0;
    uint32_t reserved_e4;
    uint32_t reserved_e8;
    uint32_t reserved_ec;
    uint32_t reserved_f0;
    uint32_t reserved_f4;
    uint32_t reserved_f8;
    uint32_t date;                                        /**/
} i2s_dev_t;
extern i2s_dev_t I2S0;
extern i2s_dev_t I2S1;

#ifdef __cplusplus
}
#endif

#endif  /* _SOC_I2S_STRUCT_H_ */`,
    i2c_dev_t: `
    // Copyright 2015-2016 Espressif Systems (Shanghai) PTE LTD
    //
    // Licensed under the Apache License, Version 2.0 (the "License");
    // you may not use this file except in compliance with the License.
    // You may obtain a copy of the License at

    //     http://www.apache.org/licenses/LICENSE-2.0
    //
    // Unless required by applicable law or agreed to in writing, software
    // distributed under the License is distributed on an "AS IS" BASIS,
    // WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    // See the License for the specific language governing permissions and
    // limitations under the License.
    #ifndef _SOC_I2C_STRUCT_H_
    #define _SOC_I2C_STRUCT_H_

    #include <stdint.h>

    #ifdef __cplusplus
    extern "C" {
    #endif

    typedef volatile struct i2c_dev_s {
        union {
            struct {
                uint32_t period:14;             /*This register is used to configure the  low level width of SCL clock.*/
                uint32_t reserved14:    18;
            };
            uint32_t val;
        } scl_low_period;
        union {
            struct {
                uint32_t sda_force_out:    1;           /*1：normally output sda data   0: exchange the function of sda_o and sda_oe (sda_o is the original internal output sda signal sda_oe is the enable bit for the internal output sda signal)*/
                uint32_t scl_force_out:    1;           /*1：normally output scl clock  0: exchange the function of scl_o and scl_oe (scl_o is the original internal output scl signal  scl_oe is the enable bit for the internal output scl signal)*/
                uint32_t sample_scl_level: 1;           /*Set this bit to sample data in SCL low level. clear this bit to sample data in SCL high level.*/
                uint32_t reserved3:        1;
                uint32_t ms_mode:          1;           /*Set this bit to configure the module as i2c master  clear this bit to configure the module as i2c slave.*/
                uint32_t trans_start:      1;           /*Set this bit to start sending data in tx_fifo.*/
                uint32_t tx_lsb_first:     1;           /*This bit is used to control the sending mode for  data need to be send. 1：receive data from most significant bit    0：receive data from least significant bit*/
                uint32_t rx_lsb_first:     1;           /*This bit is used to control the storage mode for received data. 1：receive data from most significant bit    0：receive data from least significant bit*/
                uint32_t clk_en:           1;           /*This is the clock gating control bit for reading or writing registers.*/
                uint32_t reserved9:       23;
            };
            uint32_t val;
        } ctr;
        union {
            struct {
                uint32_t ack_rec:             1;        /*This register stores the value of ACK bit.*/
                uint32_t slave_rw:            1;        /*when in slave mode  1：master read slave  0: master write slave.*/
                uint32_t time_out:            1;        /*when I2C takes more than time_out_reg clocks to receive a data then this register changes to high level.*/
                uint32_t arb_lost:            1;        /*when I2C lost control of SDA line  this register changes to high level.*/
                uint32_t bus_busy:            1;        /*1:I2C bus is busy transferring data. 0:I2C bus is in idle state.*/
                uint32_t slave_addressed:     1;        /*when configured as i2c slave  and the address send by master is equal to slave's address  then this bit will be high level.*/
                uint32_t byte_trans:          1;        /*This register changes to high level when one byte is transferred.*/
                uint32_t reserved7:           1;
                uint32_t rx_fifo_cnt:         6;        /*This register represent the amount of data need to send.*/
                uint32_t reserved14:          4;
                uint32_t tx_fifo_cnt:         6;        /*This register stores the amount of received data  in ram.*/
                uint32_t scl_main_state_last: 3;        /*This register stores the value of state machine for i2c module.  3'h0: SCL_MAIN_IDLE  3'h1: SCL_ADDRESS_SHIFT 3'h2: SCL_ACK_ADDRESS  3'h3: SCL_RX_DATA  3'h4 SCL_TX_DATA  3'h5:SCL_SEND_ACK 3'h6:SCL_WAIT_ACK*/
                uint32_t reserved27:          1;
                uint32_t scl_state_last:      3;        /*This register stores the value of state machine to produce SCL. 3'h0: SCL_IDLE  3'h1:SCL_START   3'h2:SCL_LOW_EDGE  3'h3: SCL_LOW   3'h4:SCL_HIGH_EDGE   3'h5:SCL_HIGH  3'h6:SCL_STOP*/
                uint32_t reserved31:          1;
            };
            uint32_t val;
        } status_reg;
        union {
            struct {
                uint32_t tout:      20;                 /*This register is used to configure the max clock number of receiving a data, unit: APB clock cycle.*/
                uint32_t reserved20:12;
            };
            uint32_t val;
        } timeout;
        union {
            struct {
                uint32_t addr:       15;                /*when configured as i2c slave  this register is used to configure slave's address.*/
                uint32_t reserved15: 16;
                uint32_t en_10bit:    1;                /*This register is used to enable slave 10bit address mode.*/
            };
            uint32_t val;
        } slave_addr;
        union {
            struct {
                uint32_t rx_fifo_start_addr: 5;         /*This is the offset address of the last receiving data as described in nonfifo_rx_thres_register.*/
                uint32_t rx_fifo_end_addr:   5;         /*This is the offset address of the first receiving data as described in nonfifo_rx_thres_register.*/
                uint32_t tx_fifo_start_addr: 5;         /*This is the offset address of the first  sending data as described in nonfifo_tx_thres register.*/
                uint32_t tx_fifo_end_addr:   5;         /*This is the offset address of the last  sending data as described in nonfifo_tx_thres register.*/
                uint32_t reserved20:        12;
            };
            uint32_t val;
        } fifo_st;
        union {
            struct {
                uint32_t rx_fifo_full_thrhd: 5;
                uint32_t tx_fifo_empty_thrhd:5;         /*Config tx_fifo empty threhd value when using apb fifo access*/
                uint32_t nonfifo_en:         1;         /*Set this bit to enble apb nonfifo access.*/
                uint32_t fifo_addr_cfg_en:   1;         /*When this bit is set to 1 then the byte after address represent the offset address of I2C Slave's ram.*/
                uint32_t rx_fifo_rst:        1;         /*Set this bit to reset rx fifo when using apb fifo access.*/
                uint32_t tx_fifo_rst:        1;         /*Set this bit to reset tx fifo when using apb fifo access.*/
                uint32_t nonfifo_rx_thres:   6;         /*when I2C receives more than nonfifo_rx_thres data  it will produce rx_send_full_int_raw interrupt and update the current offset address of the receiving data.*/
                uint32_t nonfifo_tx_thres:   6;         /*when I2C sends more than nonfifo_tx_thres data  it will produce tx_send_empty_int_raw interrupt and update the current offset address of the sending data.*/
                uint32_t reserved26:         6;
            };
            uint32_t val;
        } fifo_conf;
        union {
            struct {
                uint8_t data;                           /*The register represent the byte  data read from rx_fifo when use apb fifo access*/
                uint8_t reserved[3];
            };
            uint32_t val;
        } fifo_data;
        union {
            struct {
                uint32_t rx_fifo_full:     1;           /*The raw interrupt status bit for rx_fifo full when use apb fifo access.*/
                uint32_t tx_fifo_empty:    1;           /*The raw interrupt status bit for tx_fifo empty when use apb fifo access.*/
                uint32_t rx_fifo_ovf:      1;           /*The raw interrupt status bit for receiving data overflow when use apb fifo access.*/
                uint32_t end_detect:       1;           /*The raw interrupt status bit for end_detect_int interrupt. when I2C deals with  the END command  it will produce end_detect_int interrupt.*/
                uint32_t slave_tran_comp:  1;           /*The raw interrupt status bit for slave_tran_comp_int interrupt. when I2C Slave detects the STOP bit  it will produce slave_tran_comp_int interrupt.*/
                uint32_t arbitration_lost: 1;           /*The raw interrupt status bit for arbitration_lost_int interrupt.when I2C lost the usage right of I2C BUS it will produce arbitration_lost_int interrupt.*/
                uint32_t master_tran_comp: 1;           /*The raw interrupt status bit for master_tra_comp_int interrupt. when I2C Master sends or receives a byte it will produce master_tran_comp_int interrupt.*/
                uint32_t trans_complete:   1;           /*The raw interrupt status bit for trans_complete_int interrupt. when I2C Master finished STOP command  it will produce trans_complete_int interrupt.*/
                uint32_t time_out:         1;           /*The raw interrupt status bit for time_out_int interrupt. when I2C takes a lot of time to receive a data  it will produce  time_out_int interrupt.*/
                uint32_t trans_start:      1;           /*The raw interrupt status bit for trans_start_int interrupt. when I2C sends the START bit it will produce trans_start_int interrupt.*/
                uint32_t ack_err:          1;           /*The raw interrupt status bit for ack_err_int interrupt. when I2C receives a wrong ACK bit  it will produce ack_err_int interrupt..*/
                uint32_t rx_rec_full:      1;           /*The raw interrupt status bit for rx_rec_full_int interrupt. when I2C receives more data  than nonfifo_rx_thres  it will produce rx_rec_full_int interrupt.*/
                uint32_t tx_send_empty:    1;           /*The raw interrupt status bit for tx_send_empty_int interrupt.when I2C sends more data than nonfifo_tx_thres  it will produce tx_send_empty_int interrupt..*/
                uint32_t reserved13:      19;
            };
            uint32_t val;
        } int_raw;
        union {
            struct {
                uint32_t rx_fifo_full:     1;           /*Set this bit to clear the rx_fifo_full_int interrupt.*/
                uint32_t tx_fifo_empty:    1;           /*Set this bit to clear the tx_fifo_empty_int interrupt.*/
                uint32_t rx_fifo_ovf:      1;           /*Set this bit to clear the rx_fifo_ovf_int interrupt.*/
                uint32_t end_detect:       1;           /*Set this bit to clear the end_detect_int interrupt.*/
                uint32_t slave_tran_comp:  1;           /*Set this bit to clear the slave_tran_comp_int interrupt.*/
                uint32_t arbitration_lost: 1;           /*Set this bit to clear the arbitration_lost_int interrupt.*/
                uint32_t master_tran_comp: 1;           /*Set this bit to clear the master_tran_comp interrupt.*/
                uint32_t trans_complete:   1;           /*Set this bit to clear the trans_complete_int interrupt.*/
                uint32_t time_out:         1;           /*Set this bit to clear the time_out_int interrupt.*/
                uint32_t trans_start:      1;           /*Set this bit to clear the trans_start_int interrupt.*/
                uint32_t ack_err:          1;           /*Set this bit to clear the ack_err_int interrupt.*/
                uint32_t rx_rec_full:      1;           /*Set this bit to clear the rx_rec_full_int interrupt.*/
                uint32_t tx_send_empty:    1;           /*Set this bit to clear the tx_send_empty_int interrupt.*/
                uint32_t reserved13:      19;
            };
            uint32_t val;
        } int_clr;
        union {
            struct {
                uint32_t rx_fifo_full:     1;           /*The enable bit for rx_fifo_full_int interrupt.*/
                uint32_t tx_fifo_empty:    1;           /*The enable bit for tx_fifo_empty_int interrupt.*/
                uint32_t rx_fifo_ovf:      1;           /*The enable bit for rx_fifo_ovf_int interrupt.*/
                uint32_t end_detect:       1;           /*The enable bit for end_detect_int interrupt.*/
                uint32_t slave_tran_comp:  1;           /*The enable bit for slave_tran_comp_int interrupt.*/
                uint32_t arbitration_lost: 1;           /*The enable bit for arbitration_lost_int interrupt.*/
                uint32_t master_tran_comp: 1;           /*The enable bit for master_tran_comp_int interrupt.*/
                uint32_t trans_complete:   1;           /*The enable bit for trans_complete_int interrupt.*/
                uint32_t time_out:         1;           /*The enable bit for time_out_int interrupt.*/
                uint32_t trans_start:      1;           /*The enable bit for trans_start_int interrupt.*/
                uint32_t ack_err:          1;           /*The enable bit for ack_err_int interrupt.*/
                uint32_t rx_rec_full:      1;           /*The enable bit for rx_rec_full_int interrupt.*/
                uint32_t tx_send_empty:    1;           /*The enable bit for tx_send_empty_int interrupt.*/
                uint32_t reserved13:      19;
            };
            uint32_t val;
        } int_ena;
        union {
            struct {
                uint32_t rx_fifo_full:     1;            /*The masked interrupt status for rx_fifo_full_int interrupt.*/
                uint32_t tx_fifo_empty:    1;            /*The masked interrupt status for tx_fifo_empty_int interrupt.*/
                uint32_t rx_fifo_ovf:      1;            /*The masked interrupt status for rx_fifo_ovf_int interrupt.*/
                uint32_t end_detect:       1;            /*The masked interrupt status for end_detect_int interrupt.*/
                uint32_t slave_tran_comp:  1;            /*The masked interrupt status for slave_tran_comp_int interrupt.*/
                uint32_t arbitration_lost: 1;            /*The masked interrupt status for arbitration_lost_int interrupt.*/
                uint32_t master_tran_comp: 1;            /*The masked interrupt status for master_tran_comp_int interrupt.*/
                uint32_t trans_complete:   1;            /*The masked interrupt status for trans_complete_int interrupt.*/
                uint32_t time_out:         1;            /*The masked interrupt status for time_out_int interrupt.*/
                uint32_t trans_start:      1;            /*The masked interrupt status for trans_start_int interrupt.*/
                uint32_t ack_err:          1;            /*The masked interrupt status for ack_err_int interrupt.*/
                uint32_t rx_rec_full:      1;            /*The masked interrupt status for rx_rec_full_int interrupt.*/
                uint32_t tx_send_empty:    1;            /*The masked interrupt status for tx_send_empty_int interrupt.*/
                uint32_t reserved13:      19;
            };
            uint32_t val;
        } int_status;
        union {
            struct {
                uint32_t time:        10;                /*This register is used to configure the clock num I2C used to hold the data after the negedge of SCL.*/
                uint32_t reserved10:  22;
            };
            uint32_t val;
        } sda_hold;
        union {
            struct {
                uint32_t time:       10;                 /*This register is used to configure the clock num I2C used to sample data on SDA after the posedge of SCL*/
                uint32_t reserved10: 22;
            };
            uint32_t val;
        } sda_sample;
        union {
            struct {
                uint32_t period:     14;                 /*This register is used to configure the clock num during SCL is low level.*/
                uint32_t reserved14: 18;
            };
            uint32_t val;
        } scl_high_period;
        uint32_t reserved_3c;
        union {
            struct {
                uint32_t time:       10;                /*This register is used to configure the clock num between the negedge of SDA and negedge of SCL for start mark.*/
                uint32_t reserved10: 22;
            };
            uint32_t val;
        } scl_start_hold;
        union {
            struct {
                uint32_t time:       10;                /*This register is used to configure the clock num between the posedge of SCL and the negedge of SDA for restart mark.*/
                uint32_t reserved10: 22;
            };
            uint32_t val;
        } scl_rstart_setup;
        union {
            struct {
                uint32_t time:       14;                /*This register is used to configure the clock num after the STOP bit's posedge.*/
                uint32_t reserved14: 18;
            };
            uint32_t val;
        } scl_stop_hold;
        union {
            struct {
                uint32_t time:       10;                /*This register is used to configure the clock num between the posedge of SCL and the posedge of SDA.*/
                uint32_t reserved10: 22;
            };
            uint32_t val;
        } scl_stop_setup;
        union {
            struct {
                uint32_t thres:      3;                 /*When input SCL's pulse width is smaller than this register value  I2C ignores this pulse.*/
                uint32_t en:         1;                 /*This is the filter enable bit for SCL.*/
                uint32_t reserved4: 28;
            };
            uint32_t val;
        } scl_filter_cfg;
        union {
            struct {
                uint32_t thres:      3;                 /*When input SCL's pulse width is smaller than this register value  I2C ignores this pulse.*/
                uint32_t en:         1;                 /*This is the filter enable bit for SDA.*/
                uint32_t reserved4: 28;
            };
            uint32_t val;
        } sda_filter_cfg;
        union {
            struct {
                uint32_t byte_num:      8;              /*Byte_num represent the number of data need to be send or data need to be received.*/
                uint32_t ack_en:        1;              /*ack_check_en  ack_exp and ack value are used to control  the ack bit.*/
                uint32_t ack_exp:       1;              /*ack_check_en  ack_exp and ack value are used to control  the ack bit.*/
                uint32_t ack_val:       1;              /*ack_check_en  ack_exp and ack value are used to control  the ack bit.*/
                uint32_t op_code:       3;              /*op_code is the command  0：RSTART   1：WRITE  2：READ  3：STOP . 4:END.*/
                uint32_t reserved14:   17;
                uint32_t done:  1;                      /*When command0 is done in I2C Master mode  this bit changes to high level.*/
            };
            uint32_t val;
        } command[16];
        uint32_t reserved_98;
        uint32_t reserved_9c;
        uint32_t reserved_a0;
        uint32_t reserved_a4;
        uint32_t reserved_a8;
        uint32_t reserved_ac;
        uint32_t reserved_b0;
        uint32_t reserved_b4;
        uint32_t reserved_b8;
        uint32_t reserved_bc;
        uint32_t reserved_c0;
        uint32_t reserved_c4;
        uint32_t reserved_c8;
        uint32_t reserved_cc;
        uint32_t reserved_d0;
        uint32_t reserved_d4;
        uint32_t reserved_d8;
        uint32_t reserved_dc;
        uint32_t reserved_e0;
        uint32_t reserved_e4;
        uint32_t reserved_e8;
        uint32_t reserved_ec;
        uint32_t reserved_f0;
        uint32_t reserved_f4;
        uint32_t date;                                  /**/
        uint32_t reserved_fc;
        uint32_t ram_data[32];                          /*This the start address for ram when use apb nonfifo access.*/
    } i2c_dev_t;
    extern i2c_dev_t I2C0;
    extern i2c_dev_t I2C1;

    #ifdef __cplusplus
    }
    #endif

    #endif  /* _SOC_I2C_STRUCT_H_ */`,
    uart_dev_t: `
    // Copyright 2015-2016 Espressif Systems (Shanghai) PTE LTD
    //
    // Licensed under the Apache License, Version 2.0 (the "License");
    // you may not use this file except in compliance with the License.
    // You may obtain a copy of the License at

    //     http://www.apache.org/licenses/LICENSE-2.0
    //
    // Unless required by applicable law or agreed to in writing, software
    // distributed under the License is distributed on an "AS IS" BASIS,
    // WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    // See the License for the specific language governing permissions and
    // limitations under the License.
    #ifndef _SOC_UART_STRUCT_H_
    #define _SOC_UART_STRUCT_H_

    #include <stdint.h>

    #ifdef __cplusplus
    extern "C" {
    #endif

    typedef volatile struct uart_dev_s {
        union {
            struct {
                uint8_t rw_byte;                 /*This register stores one byte data  read by rx fifo.*/
                uint8_t reserved[3];
            };
            uint32_t val;
        } fifo;
        union {
            struct {
                uint32_t rxfifo_full:      1;           /*This interrupt raw bit turns to high level when receiver receives more data than (rx_flow_thrhd_h3 rx_flow_thrhd).*/
                uint32_t txfifo_empty:     1;           /*This interrupt raw bit turns to high level when the amount of data in transmitter's fifo is less than ((tx_mem_cnttxfifo_cnt) .*/
                uint32_t parity_err:       1;           /*This interrupt raw bit turns to high level when receiver detects the parity error of data.*/
                uint32_t frm_err:          1;           /*This interrupt raw bit turns to high level when receiver detects data's frame error .*/
                uint32_t rxfifo_ovf:       1;           /*This interrupt raw bit turns to high level when receiver receives more data than the fifo can store.*/
                uint32_t dsr_chg:          1;           /*This interrupt raw bit turns to high level when receiver detects the edge change of dsrn signal.*/
                uint32_t cts_chg:          1;           /*This interrupt raw bit turns to high level when receiver detects the edge change of ctsn signal.*/
                uint32_t brk_det:          1;           /*This interrupt raw bit turns to high level when receiver detects the 0 after the stop bit.*/
                uint32_t rxfifo_tout:      1;           /*This interrupt raw bit turns to high level when receiver takes more time than rx_tout_thrhd to receive a byte.*/
                uint32_t sw_xon:           1;           /*This interrupt raw bit turns to high level when receiver receives xoff char with uart_sw_flow_con_en is set to 1.*/
                uint32_t sw_xoff:          1;           /*This interrupt raw bit turns to high level when receiver receives xon char with uart_sw_flow_con_en is set to 1.*/
                uint32_t glitch_det:       1;           /*This interrupt raw bit turns to high level when receiver detects the start bit.*/
                uint32_t tx_brk_done:      1;           /*This interrupt raw bit turns to high level when transmitter completes  sending  0 after all the data in transmitter's fifo are send.*/
                uint32_t tx_brk_idle_done: 1;           /*This interrupt raw bit turns to high level when transmitter has kept the shortest duration after the  last data has been send.*/
                uint32_t tx_done:          1;           /*This interrupt raw bit turns to high level when transmitter has send all the data in fifo.*/
                uint32_t rs485_parity_err: 1;           /*This interrupt raw bit turns to high level when rs485 detects the parity error.*/
                uint32_t rs485_frm_err:    1;           /*This interrupt raw bit turns to high level when rs485 detects the data frame error.*/
                uint32_t rs485_clash:      1;           /*This interrupt raw bit turns to high level when rs485 detects the clash between transmitter and receiver.*/
                uint32_t at_cmd_char_det:  1;           /*This interrupt raw bit turns to high level when receiver detects the configured at_cmd chars.*/
                uint32_t reserved19:      13;
            };
            uint32_t val;
        } int_raw;
        union {
            struct {
                uint32_t rxfifo_full:      1;            /*This is the status bit for rxfifo_full_int_raw when rxfifo_full_int_ena is set to 1.*/
                uint32_t txfifo_empty:     1;            /*This is the status bit for  txfifo_empty_int_raw  when txfifo_empty_int_ena is set to 1.*/
                uint32_t parity_err:       1;            /*This is the status bit for parity_err_int_raw when parity_err_int_ena is set to 1.*/
                uint32_t frm_err:          1;            /*This is the status bit for frm_err_int_raw when fm_err_int_ena is set to 1.*/
                uint32_t rxfifo_ovf:       1;            /*This is the status bit for rxfifo_ovf_int_raw when rxfifo_ovf_int_ena is set to 1.*/
                uint32_t dsr_chg:          1;            /*This is the status bit for dsr_chg_int_raw when dsr_chg_int_ena is set to 1.*/
                uint32_t cts_chg:          1;            /*This is the status bit for cts_chg_int_raw when cts_chg_int_ena is set to 1.*/
                uint32_t brk_det:          1;            /*This is the status bit for brk_det_int_raw when brk_det_int_ena is set to 1.*/
                uint32_t rxfifo_tout:      1;            /*This is the status bit for rxfifo_tout_int_raw when rxfifo_tout_int_ena is set to 1.*/
                uint32_t sw_xon:           1;            /*This is the status bit for sw_xon_int_raw when sw_xon_int_ena is set to 1.*/
                uint32_t sw_xoff:          1;            /*This is the status bit for sw_xoff_int_raw when sw_xoff_int_ena is set to 1.*/
                uint32_t glitch_det:       1;            /*This is the status bit for glitch_det_int_raw when glitch_det_int_ena is set to 1.*/
                uint32_t tx_brk_done:      1;            /*This is the status bit for tx_brk_done_int_raw when tx_brk_done_int_ena is set to 1.*/
                uint32_t tx_brk_idle_done: 1;            /*This is the status bit for tx_brk_idle_done_int_raw when tx_brk_idle_done_int_ena is set to 1.*/
                uint32_t tx_done:          1;            /*This is the status bit for tx_done_int_raw when tx_done_int_ena is set to 1.*/
                uint32_t rs485_parity_err: 1;            /*This is the status bit for rs485_parity_err_int_raw when rs485_parity_int_ena is set to 1.*/
                uint32_t rs485_frm_err:    1;            /*This is the status bit for rs485_fm_err_int_raw when rs485_fm_err_int_ena is set to 1.*/
                uint32_t rs485_clash:      1;            /*This is the status bit for rs485_clash_int_raw when rs485_clash_int_ena is set to 1.*/
                uint32_t at_cmd_char_det:  1;            /*This is the status bit for at_cmd_det_int_raw when at_cmd_char_det_int_ena is set to 1.*/
                uint32_t reserved19:      13;
            };
            uint32_t val;
        } int_st;
        union {
            struct {
                uint32_t rxfifo_full:      1;           /*This is the enable bit for rxfifo_full_int_st register.*/
                uint32_t txfifo_empty:     1;           /*This is the enable bit for rxfifo_full_int_st register.*/
                uint32_t parity_err:       1;           /*This is the enable bit for parity_err_int_st register.*/
                uint32_t frm_err:          1;           /*This is the enable bit for frm_err_int_st register.*/
                uint32_t rxfifo_ovf:       1;           /*This is the enable bit for rxfifo_ovf_int_st register.*/
                uint32_t dsr_chg:          1;           /*This is the enable bit for dsr_chg_int_st register.*/
                uint32_t cts_chg:          1;           /*This is the enable bit for cts_chg_int_st register.*/
                uint32_t brk_det:          1;           /*This is the enable bit for brk_det_int_st register.*/
                uint32_t rxfifo_tout:      1;           /*This is the enable bit for rxfifo_tout_int_st register.*/
                uint32_t sw_xon:           1;           /*This is the enable bit for sw_xon_int_st register.*/
                uint32_t sw_xoff:          1;           /*This is the enable bit for sw_xoff_int_st register.*/
                uint32_t glitch_det:       1;           /*This is the enable bit for glitch_det_int_st register.*/
                uint32_t tx_brk_done:      1;           /*This is the enable bit for tx_brk_done_int_st register.*/
                uint32_t tx_brk_idle_done: 1;           /*This is the enable bit for tx_brk_idle_done_int_st register.*/
                uint32_t tx_done:          1;           /*This is the enable bit for tx_done_int_st register.*/
                uint32_t rs485_parity_err: 1;           /*This is the enable bit for rs485_parity_err_int_st register.*/
                uint32_t rs485_frm_err:    1;           /*This is the enable bit for rs485_parity_err_int_st register.*/
                uint32_t rs485_clash:      1;           /*This is the enable bit for rs485_clash_int_st register.*/
                uint32_t at_cmd_char_det:  1;           /*This is the enable bit for at_cmd_char_det_int_st register.*/
                uint32_t reserved19:      13;
            };
            uint32_t val;
        } int_ena;
        union {
            struct {
                uint32_t rxfifo_full:      1;           /*Set this bit to clear the rxfifo_full_int_raw interrupt.*/
                uint32_t txfifo_empty:     1;           /*Set this bit to clear txfifo_empty_int_raw interrupt.*/
                uint32_t parity_err:       1;           /*Set this bit to clear parity_err_int_raw interrupt.*/
                uint32_t frm_err:          1;           /*Set this bit to clear frm_err_int_raw interrupt.*/
                uint32_t rxfifo_ovf:       1;           /*Set this bit to clear rxfifo_ovf_int_raw interrupt.*/
                uint32_t dsr_chg:          1;           /*Set this bit to clear the dsr_chg_int_raw interrupt.*/
                uint32_t cts_chg:          1;           /*Set this bit to clear the cts_chg_int_raw interrupt.*/
                uint32_t brk_det:          1;           /*Set this bit to clear the brk_det_int_raw interrupt.*/
                uint32_t rxfifo_tout:      1;           /*Set this bit to clear the rxfifo_tout_int_raw interrupt.*/
                uint32_t sw_xon:           1;           /*Set this bit to clear the sw_xon_int_raw interrupt.*/
                uint32_t sw_xoff:          1;           /*Set this bit to clear the sw_xon_int_raw interrupt.*/
                uint32_t glitch_det:       1;           /*Set this bit to clear the glitch_det_int_raw interrupt.*/
                uint32_t tx_brk_done:      1;           /*Set this bit to clear the tx_brk_done_int_raw interrupt..*/
                uint32_t tx_brk_idle_done: 1;           /*Set this bit to clear the tx_brk_idle_done_int_raw interrupt.*/
                uint32_t tx_done:          1;           /*Set this bit to clear the tx_done_int_raw interrupt.*/
                uint32_t rs485_parity_err: 1;           /*Set this bit to clear the rs485_parity_err_int_raw interrupt.*/
                uint32_t rs485_frm_err:    1;           /*Set this bit to clear the rs485_frm_err_int_raw interrupt.*/
                uint32_t rs485_clash:      1;           /*Set this bit to clear the rs485_clash_int_raw interrupt.*/
                uint32_t at_cmd_char_det:  1;           /*Set this bit to clear the at_cmd_char_det_int_raw interrupt.*/
                uint32_t reserved19:      13;
            };
            uint32_t val;
        } int_clr;
        union {
            struct {
                uint32_t div_int:    20;                /*The register value is  the  integer part of the frequency divider's factor.*/
                uint32_t div_frag:    4;                /*The register  value is the decimal part of the frequency divider's factor.*/
                uint32_t reserved24:  8;
            };
            uint32_t val;
        } clk_div;
        union {
            struct {
                uint32_t en: 1;                         /*This is the enable bit for detecting baudrate.*/
                uint32_t reserved1:   7;
                uint32_t glitch_filt: 8;                /*when input pulse width is lower then this value ignore this pulse.this register is used in auto-baud detect process.*/
                uint32_t reserved16: 16;
            };
            uint32_t val;
        } auto_baud;
        union {
            struct {
                uint32_t rxfifo_cnt: 8;                 /*(rx_mem_cnt rxfifo_cnt) stores the byte number of valid data in receiver's fifo. rx_mem_cnt register stores the 3 most significant bits  rxfifo_cnt stores the 8 least significant bits.*/
                uint32_t st_urx_out: 4;                 /*This register stores the value of receiver's finite state machine. 0:RX_IDLE  1:RX_STRT  2:RX_DAT0  3:RX_DAT1  4:RX_DAT2  5:RX_DAT3  6:RX_DAT4  7:RX_DAT5  8:RX_DAT6  9:RX_DAT7   10:RX_PRTY   11:RX_STP1  12:RX_STP2 13:RX_DL1*/
                uint32_t reserved12: 1;
                uint32_t dsrn:       1;                 /*This register stores the level value of the internal uart dsr signal.*/
                uint32_t ctsn:       1;                 /*This register stores the level value of the internal uart cts signal.*/
                uint32_t rxd:        1;                 /*This register stores the level value of the internal uart rxd signal.*/
                uint32_t txfifo_cnt: 8;                 /*(tx_mem_cnt txfifo_cnt) stores the byte number of valid data in transmitter's fifo.tx_mem_cnt stores the 3 most significant bits  txfifo_cnt stores the 8 least significant bits.*/
                uint32_t st_utx_out: 4;                 /*This register stores the value of transmitter's finite state machine. 0:TX_IDLE  1:TX_STRT  2:TX_DAT0  3:TX_DAT1  4:TX_DAT2   5:TX_DAT3 6:TX_DAT4  7:TX_DAT5  8:TX_DAT6 9:TX_DAT7  10:TX_PRTY   11:TX_STP1  12:TX_STP2  13:TX_DL0   14:TX_DL1*/
                uint32_t reserved28: 1;
                uint32_t dtrn:       1;                 /*The register represent the level value of the internal uart dsr signal.*/
                uint32_t rtsn:       1;                 /*This register represent the level value of the internal uart cts signal.*/
                uint32_t txd:        1;                 /*This register represent the  level value of the internal uart rxd signal.*/
            };
            uint32_t val;
        } status;
        union {
            struct {
                uint32_t parity:             1;         /*This register is used to configure the parity check mode.  0:even 1:odd*/
                uint32_t parity_en:          1;         /*Set this bit to enable uart parity check.*/
                uint32_t bit_num:            2;         /*This register is used to set the length of data:  0:5bits 1:6bits 2:7bits 3:8bits*/
                uint32_t stop_bit_num:       2;         /*This register is used to set the length of  stop bit. 1:1bit  2:1.5bits  3:2bits*/
                uint32_t sw_rts:             1;         /*This register is used to configure the software rts signal which is used in software flow control.*/
                uint32_t sw_dtr:             1;         /*This register is used to configure the software dtr signal which is used in software flow control..*/
                uint32_t txd_brk:            1;         /*Set this bit to enable transmitter to  send 0 when the process of sending data is done.*/
                uint32_t irda_dplx:          1;         /*Set this bit to enable irda loop-back mode.*/
                uint32_t irda_tx_en:         1;         /*This is the start enable bit for irda transmitter.*/
                uint32_t irda_wctl:          1;         /*1：the irda transmitter's 11th bit is the same to the 10th bit. 0：set irda transmitter's 11th bit to 0.*/
                uint32_t irda_tx_inv:        1;         /*Set this bit to inverse the level value of  irda transmitter's level.*/
                uint32_t irda_rx_inv:        1;         /*Set this bit to inverse the level value of irda receiver's level.*/
                uint32_t loopback:           1;         /*Set this bit to enable uart loop-back test mode.*/
                uint32_t tx_flow_en:         1;         /*Set this bit to enable transmitter's flow control function.*/
                uint32_t irda_en:            1;         /*Set this bit to enable irda protocol.*/
                uint32_t rxfifo_rst:         1;         /*Set this bit to reset uart receiver's fifo.*/
                uint32_t txfifo_rst:         1;         /*Set this bit to reset uart transmitter's fifo.*/
                uint32_t rxd_inv:            1;         /*Set this bit to inverse the level value of uart rxd signal.*/
                uint32_t cts_inv:            1;         /*Set this bit to inverse the level value of uart cts signal.*/
                uint32_t dsr_inv:            1;         /*Set this bit to inverse the level value of uart dsr signal.*/
                uint32_t txd_inv:            1;         /*Set this bit to inverse the level value of uart txd signal.*/
                uint32_t rts_inv:            1;         /*Set this bit to inverse the level value of uart rts signal.*/
                uint32_t dtr_inv:            1;         /*Set this bit to inverse the level value of uart dtr signal.*/
                uint32_t clk_en:             1;         /*1：force clock on for registers：support clock only when write registers*/
                uint32_t err_wr_mask:        1;         /*1：receiver stops storing data int fifo when data is wrong. 0：receiver stores the data even if the  received data is wrong.*/
                uint32_t tick_ref_always_on: 1;         /*This register is used to select the clock.1：apb clock：ref_tick*/
                uint32_t reserved28:         4;
            };
            uint32_t val;
        } conf0;
        union {
            struct {
                uint32_t rxfifo_full_thrhd:  7;         /*When receiver receives more data than its threshold value，receiver will produce rxfifo_full_int_raw interrupt.the threshold value is (rx_flow_thrhd_h3 rxfifo_full_thrhd).*/
                uint32_t reserved7:          1;
                uint32_t txfifo_empty_thrhd: 7;         /*when the data amount in transmitter fifo is less than its threshold value， it will produce txfifo_empty_int_raw interrupt. the threshold value is (tx_mem_empty_thrhd txfifo_empty_thrhd)*/
                uint32_t reserved15:         1;
                uint32_t rx_flow_thrhd:      7;         /*when receiver receives more data than its threshold value， receiver produce signal to tell the transmitter stop transferring data. the threshold value is (rx_flow_thrhd_h3 rx_flow_thrhd).*/
                uint32_t rx_flow_en:         1;         /*This is the flow enable bit for uart receiver. 1:choose software flow control with configuring sw_rts signal*/
                uint32_t rx_tout_thrhd:      7;         /*This register is used to configure the timeout value for uart receiver receiving a byte.*/
                uint32_t rx_tout_en:         1;         /*This is the enable bit for uart receiver's timeout function.*/
            };
            uint32_t val;
        } conf1;
        union {
            struct {
                uint32_t min_cnt:     20;               /*This register stores the value of the minimum duration time for the low level pulse， it is used in baudrate-detect process.*/
                uint32_t reserved20:  12;
            };
            uint32_t val;
        } lowpulse;
        union {
            struct {
                uint32_t min_cnt:     20;               /*This register stores  the value of the maximum duration time for the high level pulse， it is used in baudrate-detect process.*/
                uint32_t reserved20:  12;
            };
            uint32_t val;
        } highpulse;
        union {
            struct {
                uint32_t edge_cnt:    10;               /*This register stores the count of rxd edge change， it is used in baudrate-detect process.*/
                uint32_t reserved10:  22;
            };
            uint32_t val;
        } rxd_cnt;
        union {
            struct {
                uint32_t sw_flow_con_en: 1;             /*Set this bit to enable software  flow control. it is used with register sw_xon or sw_xoff .*/
                uint32_t xonoff_del:     1;             /*Set this bit to remove flow control char from the received data.*/
                uint32_t force_xon:      1;             /*Set this bit to clear ctsn to stop the  transmitter from sending data.*/
                uint32_t force_xoff:     1;             /*Set this bit to set ctsn to enable the transmitter to go on sending data.*/
                uint32_t send_xon:       1;             /*Set this bit to send xon char， it is cleared by hardware automatically.*/
                uint32_t send_xoff:      1;             /*Set this bit to send xoff char， it is cleared by hardware automatically.*/
                uint32_t reserved6:     26;
            };
            uint32_t val;
        } flow_conf;
        union {
            struct {
                uint32_t active_threshold:10;           /*When the input rxd edge changes more than this register value， the uart is active from light sleeping mode.*/
                uint32_t reserved10:      22;
            };
            uint32_t val;
        } sleep_conf;
        union {
            struct {
                uint32_t xon_threshold:  8;             /*when the data amount in receiver's fifo is more than this register value， it will send a xoff char with uart_sw_flow_con_en set to 1.*/
                uint32_t xoff_threshold: 8;             /*When the data amount in receiver's fifo is less than this register value， it will send a xon char with uart_sw_flow_con_en set to 1.*/
                uint32_t xon_char:       8;             /*This register stores the xon flow control char.*/
                uint32_t xoff_char:      8;             /*This register stores the xoff flow control char.*/
            };
            uint32_t val;
        } swfc_conf;
        union {
            struct {
                uint32_t rx_idle_thrhd:10;              /*when receiver takes more time than this register value to receive a byte data， it will produce frame end signal for uhci to stop receiving data.*/
                uint32_t tx_idle_num:  10;              /*This register is used to configure the duration time between transfers.*/
                uint32_t tx_brk_num:    8;              /*This register is used to configure the number of 0 send after the process of sending data is done. it is active when txd_brk is set to 1.*/
                uint32_t reserved28:    4;
            };
            uint32_t val;
        } idle_conf;
        union {
            struct {
                uint32_t en:               1;           /*Set this bit to choose rs485 mode.*/
                uint32_t dl0_en:           1;           /*Set this bit to delay the stop bit by 1 bit.*/
                uint32_t dl1_en:           1;           /*Set this bit to delay the stop bit by 1 bit.*/
                uint32_t tx_rx_en:         1;           /*Set this bit to enable loop-back transmitter's output data signal to receiver's input data signal.*/
                uint32_t rx_busy_tx_en:    1;           /*1: enable rs485's transmitter to send data when rs485's receiver is busy. 0:rs485's transmitter should not send data when its receiver is busy.*/
                uint32_t rx_dly_num:       1;           /*This register is used to delay the receiver's internal data signal.*/
                uint32_t tx_dly_num:       4;           /*This register is used to delay the transmitter's internal data signal.*/
                uint32_t reserved10:      22;
            };
            uint32_t val;
        } rs485_conf;
        union {
            struct {
                uint32_t pre_idle_num:24;               /*This register is used to configure the idle duration time before the first at_cmd is received by receiver， when the the duration is less than this register value it will not take the next data received as at_cmd char.*/
                uint32_t reserved24:   8;
            };
            uint32_t val;
        } at_cmd_precnt;
        union {
            struct {
                uint32_t post_idle_num:24;              /*This register is used to configure the duration time between the last at_cmd and the next data， when the duration is less than this register value  it will not take the previous data as at_cmd char.*/
                uint32_t reserved24:    8;
            };
            uint32_t val;
        } at_cmd_postcnt;
        union {
            struct {
                uint32_t rx_gap_tout:24;                /*This register is used to configure the duration time between the at_cmd chars， when the duration time is less than this register value it will not take the data as continous at_cmd chars.*/
                uint32_t reserved24:  8;
            };
            uint32_t val;
        } at_cmd_gaptout;
        union {
            struct {
                uint32_t data:        8;                /*This register is used to configure the content of at_cmd char.*/
                uint32_t char_num:    8;                /*This register is used to configure the number of continuous at_cmd chars received by receiver.*/
                uint32_t reserved16: 16;
            };
            uint32_t val;
        } at_cmd_char;
        union {
            struct {
                uint32_t mem_pd:             1;         /*Set this bit to power down memory，when reg_mem_pd registers in the 3 uarts are all set to 1  memory will enter low power mode.*/
                uint32_t reserved1:          1;
                uint32_t reserved2:          1;
                uint32_t rx_size:            4;         /*This register is used to configure the amount of mem allocated to receiver's fifo. the default byte num is 128.*/
                uint32_t tx_size:            4;         /*This register is used to configure the amount of mem allocated to transmitter's fifo.the default byte num is 128.*/
                uint32_t reserved11:         4;
                uint32_t rx_flow_thrhd_h3:   3;         /*refer to the rx_flow_thrhd's description.*/
                uint32_t rx_tout_thrhd_h3:   3;         /*refer to the rx_tout_thrhd's description.*/
                uint32_t xon_threshold_h2:   2;         /*refer to the uart_xon_threshold's description.*/
                uint32_t xoff_threshold_h2:  2;         /*refer to the uart_xoff_threshold's description.*/
                uint32_t rx_mem_full_thrhd:  3;         /*refer to the rxfifo_full_thrhd's description.*/
                uint32_t tx_mem_empty_thrhd: 3;         /*refer to txfifo_empty_thrhd 's description.*/
                uint32_t reserved31:         1;
            };
            uint32_t val;
        } mem_conf;
        union {
            struct {
                uint32_t status:24;
                uint32_t reserved24:    8;
            };
            uint32_t val;
        } mem_tx_status;
        union {
            struct {
                uint32_t status:      24;
                uint32_t reserved24:   8;
            };
            struct {
                uint32_t reserved0:     2;
                uint32_t rd_addr:      11;              /*This register stores the rx mem read address.*/
                uint32_t wr_addr:      11;              /*This register stores the rx mem write address.*/
                uint32_t reserved:      8;
            };
            uint32_t val;
        } mem_rx_status;
        union {
            struct {
                uint32_t rx_cnt: 3;                      /*refer to the rxfifo_cnt's description.*/
                uint32_t tx_cnt: 3;                      /*refer to the txfifo_cnt's description.*/
                uint32_t reserved6: 26;
            };
            uint32_t val;
        } mem_cnt_status;
        union {
            struct {
                uint32_t min_cnt:     20;                 /*This register stores the count of rxd pos-edge edge， it is used in baudrate-detect process.*/
                uint32_t reserved20:  12;
            };
            uint32_t val;
        } pospulse;
        union {
            struct {
                uint32_t min_cnt:     20;                 /*This register stores the count of rxd neg-edge edge， it is used in baudrate-detect process.*/
                uint32_t reserved20:  12;
            };
            uint32_t val;
        } negpulse;
        uint32_t reserved_70;
        uint32_t reserved_74;
        uint32_t date;                                    /**/
        uint32_t id;                                      /**/
    } uart_dev_t;
    extern uart_dev_t UART0;
    extern uart_dev_t UART1;
    extern uart_dev_t UART2;

    #ifdef __cplusplus
    }
    #endif

    #endif  /* _SOC_UART_STRUCT_H_ */`
}